(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.announcement-bar').forEach((bar) => {
    const key = bar.dataset.dismissKey;

    // Restore a previous dismissal (persisted per message content).
    if (key) {
      try {
        if (localStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {
        /* localStorage unavailable — show the bar */
      }

      const closeBtn = bar.querySelector('[data-announcement-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          bar.hidden = true;
          try {
            localStorage.setItem(key, '1');
          } catch (e) {
            /* ignore persistence failure */
          }
        });
      }
    }

    // Auto-rotate multiple messages.
    const speed = parseInt(bar.dataset.autorotate, 10);
    if (!speed) return;

    const items = Array.from(bar.querySelectorAll('.announcement-bar__item'));
    if (items.length < 2) return;

    let current = 0;
    setInterval(() => {
      items[current].hidden = true;
      current = (current + 1) % items.length;
      items[current].hidden = false;
    }, speed * 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-application-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.b2bReady === 'true') return;
      root.dataset.b2bReady = 'true';

      var form = root.querySelector('form');
      if (!form) return;

      form.setAttribute('novalidate', 'novalidate');

      var titleEl = root.querySelector('[data-b2b-step-title]');
      var titlesNode = root.querySelector('[data-b2b-step-titles]');
      var titles = { 1: '', 2: '', 3: '' };
      try {
        if (titlesNode) titles = JSON.parse(titlesNode.textContent);
      } catch (e) {}

      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-b2b-step]'));
      var progress = Array.prototype.slice.call(root.querySelectorAll('[data-b2b-progress]'));
      var nextBtn = root.querySelector('[data-b2b-next]');
      var backBtn = root.querySelector('[data-b2b-back]');
      var submitBtn = root.querySelector('[data-b2b-submit]');
      var bodyInput = root.querySelector('[data-b2b-body]');
      var successEl = root.querySelector('[data-b2b-success]');
      var current = 1;

      if (successEl) {
        successEl.focus();
        return;
      }

      function getStep(n) {
        return root.querySelector('[data-b2b-step="' + n + '"]');
      }

      function syncRequired(n) {
        steps.forEach(function (step) {
          var active = Number(step.getAttribute('data-b2b-step')) === n;
          Array.prototype.forEach.call(step.querySelectorAll('[data-b2b-field]'), function (field) {
            if (field.dataset.wasRequired === 'true') {
              if (active) field.setAttribute('required', 'required');
              else field.removeAttribute('required');
            }
          });
        });
      }

      function rememberRequired() {
        Array.prototype.forEach.call(root.querySelectorAll('[data-b2b-field][required]'), function (field) {
          field.dataset.wasRequired = 'true';
        });
      }

      function setStep(n) {
        current = n;
        steps.forEach(function (step) {
          var active = Number(step.getAttribute('data-b2b-step')) === n;
          step.hidden = !active;
        });

        progress.forEach(function (el) {
          var stepNum = Number(el.getAttribute('data-b2b-progress'));
          var active = stepNum === n;
          el.classList.toggle('is-active', active);
          el.setAttribute('aria-current', active ? 'step' : 'false');
        });

        syncRequired(n);

        if (titleEl && titles[String(n)]) titleEl.textContent = titles[String(n)];
        if (nextBtn) nextBtn.hidden = n === 3;
        if (submitBtn) submitBtn.hidden = n !== 3;
        if (backBtn) backBtn.hidden = n === 1;

        var focusTarget = getStep(n).querySelector('input, select, textarea');
        if (focusTarget) focusTarget.focus({ preventScroll: false });
      }

      function validateStep(n) {
        var step = getStep(n);
        if (!step) return true;
        var fields = Array.prototype.slice.call(step.querySelectorAll('[data-b2b-field]'));
        var valid = true;
        fields.forEach(function (field) {
          if (!field.checkValidity()) {
            if (valid) field.reportValidity();
            valid = false;
          }
        });
        return valid;
      }

      function buildBody() {
        if (!bodyInput) return;
        var lines = ['B2B application submission', ''];
        var fields = Array.prototype.slice.call(form.querySelectorAll('[data-b2b-field]'));
        fields.forEach(function (field) {
          var label = field.name;
          if (field.id) {
            var labelEl = form.querySelector('label[for="' + field.id + '"]');
            if (labelEl) label = labelEl.textContent.replace(/\*$/, '').trim();
          }
          lines.push(label + ': ' + (field.value || ''));
        });
        bodyInput.value = lines.join('\n');
      }

      rememberRequired();

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          if (!validateStep(current)) return;
          if (current < 3) setStep(current + 1);
        });
      }

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          if (current > 1) setStep(current - 1);
        });
      }

      form.addEventListener('submit', function (event) {
        if (current !== 3 || !validateStep(3)) {
          event.preventDefault();
          if (current !== 3) setStep(3);
          return;
        }
        syncRequired(3);
        Array.prototype.forEach.call(root.querySelectorAll('[data-b2b-field]'), function (field) {
          if (field.dataset.wasRequired === 'true') field.setAttribute('required', 'required');
        });
        var allValid = true;
        Array.prototype.forEach.call(root.querySelectorAll('[data-b2b-field]'), function (field) {
          if (!field.checkValidity()) {
            var stepEl = field.closest('[data-b2b-step]');
            if (stepEl) setStep(Number(stepEl.getAttribute('data-b2b-step')));
            field.reportValidity();
            allValid = false;
          }
        });
        if (!allValid) {
          event.preventDefault();
          return;
        }
        buildBody();
      });

      setStep(1);
    }

    document.querySelectorAll('[data-b2b-application]').forEach(init);

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-b2b-application]');
      if (root) {
        root.dataset.b2bReady = 'false';
        init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-request-login"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.b2bReady === 'true') return;
      root.dataset.b2bReady = 'true';

      var form = root.querySelector('form');
      if (!form) return;

      var bodyInput = root.querySelector('[data-b2b-body]');
      var successEl = root.querySelector('[data-b2b-success]');

      if (successEl) {
        successEl.focus();
        return;
      }

      form.addEventListener('submit', function () {
        if (!bodyInput) return;
        var lines = ['B2B web login request', ''];
        Array.prototype.forEach.call(form.querySelectorAll('[data-b2b-field]'), function (field) {
          var label = field.name;
          if (field.id) {
            var labelEl = form.querySelector('label[for="' + field.id + '"]');
            if (labelEl) label = labelEl.textContent.replace(/\*$/, '').trim();
          }
          lines.push(label + ': ' + (field.value || ''));
        });
        bodyInput.value = lines.join('\n');
      });
    }

    document.querySelectorAll('[data-b2b-request-login]').forEach(init);

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-b2b-request-login]');
      if (root) {
        root.dataset.b2bReady = 'false';
        init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-b2b-testimonials]').forEach((section) => {
    const track = section.querySelector('[data-b2b-testimonials-track]');
    if (!track) return;

    const prev = section.querySelector('[data-b2b-testimonials-prev]');
    const next = section.querySelector('[data-b2b-testimonials-next]');

    const step = () => {
      const card = track.querySelector('.b2b-testimonials__card');
      if (!card) return 381;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 10;
      return card.getBoundingClientRect().width + gap;
    };

    const sync = () => {
      const atStart = track.scrollLeft <= 1;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    };

    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  class BlogRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rail-track]');
      const prev = this.querySelector('[data-rail-prev]');
      const next = this.querySelector('[data-rail-next]');
      if (!this.track) return;
      const step = () => {
        const item = this.track.querySelector('.blog-card');
        return item ? item.getBoundingClientRect().width + 32 : 400;
      };
      if (prev) prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      const sync = () => {
        if (prev) prev.disabled = this.track.scrollLeft <= 1;
        if (next) next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
      };
      this.track.addEventListener('scroll', sync, { passive: true });
      sync();
    }
  }
  if (!customElements.get('blog-rail')) customElements.define('blog-rail', BlogRail);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.loading = false;
      this.bind();
      this.loadRecommendations();
    }

    bind() {
      this.querySelectorAll('[data-cart-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.querySelectorAll('[data-qty-change]').forEach((btn) => btn.addEventListener('click', () => this.changeQuantity(btn)));
      this.bindCarousel();
    }

    bindCarousel() {
      const track = this.querySelector('[data-recs-grid]');
      if (!track) return;
      const prev = this.querySelector('[data-recs-prev]');
      const next = this.querySelector('[data-recs-next]');
      const step = () => {
        const card = track.querySelector('.cart-drawer__recs-item');
        return card ? card.getBoundingClientRect().width + 12 : 232;
      };
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

      const sync = () => {
        const atStart = track.scrollLeft <= 1;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      };
      track.addEventListener('scroll', sync, { passive: true });
      this._syncRecsArrows = sync;
      sync();
    }

    open() {
      this.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      if (window.__cartAddNotification && typeof window.__cartAddNotification.hide === 'function') {
        window.__cartAddNotification.hide();
      }
      this.loadRecommendations();
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    async changeQuantity(btn) {
      if (this.loading) return;
      const line = btn.closest('[data-cart-line]');
      if (!line) return;
      const key = line.dataset.key;
      const quantity = parseInt(btn.dataset.qtyChange, 10);
      const fallbackError = this.dataset.errorUpdate || 'Could not update your cart.';
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      this.querySelectorAll('[data-qty-change]').forEach((b) => (b.disabled = true));

      try {
        const changeUrl = (this.dataset.cartChangeUrl || '/cart/change') + '.js';
        const res = await fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity, sections: this.sectionId }),
        });
        const data = await res.json();
        if (!res.ok) {
          this.showError(data.description || data.message || fallbackError);
          this.querySelectorAll('[data-qty-change]').forEach((b) => (b.disabled = false));
          return;
        }
        const html = data.sections && data.sections[this.sectionId];
        if (html) this.replaceContents(html);
        this.updateHeaderCount(data.item_count);
      } catch (e) {
        this.showError(fallbackError);
        this.querySelectorAll('[data-qty-change]').forEach((b) => (b.disabled = false));
      } finally {
        this.loading = false;
        this.removeAttribute('aria-busy');
      }
    }

    showError(message) {
      let banner = this.querySelector('.cart-drawer__error');
      if (!banner) {
        banner = document.createElement('p');
        banner.className = 'cart-drawer__error';
        banner.setAttribute('role', 'alert');
        const header = this.querySelector('.cart-drawer__header');
        if (header) header.insertAdjacentElement('afterend', banner);
      }
      banner.textContent = message;
      clearTimeout(this._errTimer);
      this._errTimer = setTimeout(() => banner && banner.remove(), 4000);
    }

    replaceContents(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('cart-drawer');
      if (!fresh) return;
      this.innerHTML = fresh.innerHTML;
      if (fresh.dataset.recommendId) this.dataset.recommendId = fresh.dataset.recommendId;
      else this.removeAttribute('data-recommend-id');
      // Keep host open-state as-is so subsequent adds can refresh HTML without opening.
      this.bind();
      this._recsLoaded = false;
      if (this.classList.contains('is-open')) this.loadRecommendations();
    }

    async loadRecommendations() {
      const grid = this.querySelector('[data-recs-grid]');
      const block = this.querySelector('[data-cart-recs]');
      if (!grid || !block) return;
      if (this._recsLoaded) return;
      this._recsLoaded = true;

      // Prefer real product recommendations; keep the server-rendered fallback otherwise.
      const pid = this.dataset.recommendId;
      if (pid) {
        try {
          const url = `/recommendations/products?section_id=cart-recommendations&product_id=${pid}&limit=8&intent=related`;
          const res = await fetch(url);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const fresh = doc.querySelector('[data-recs-grid]');
          if (fresh && fresh.children.length) grid.innerHTML = fresh.innerHTML;
        } catch (e) {
          /* keep the fallback grid */
        }
      }
      block.hidden = grid.children.length === 0;
      if (typeof this._syncRecsArrows === 'function') this._syncRecsArrows();
    }

    updateHeaderCount(count) {
      const cart = document.querySelector('.header__cart');
      if (!cart) return;

      // Scope to the cart icon — wishlist reuses .header__cart-count earlier in the header.
      const badges = cart.querySelectorAll('[data-cart-count], .header__cart-count');
      if (count > 0) {
        if (!badges.length) {
          const badge = document.createElement('span');
          badge.className = 'header__cart-count';
          badge.setAttribute('data-cart-count', '');
          badge.setAttribute('aria-hidden', 'true');
          cart.appendChild(badge);
          badge.textContent = String(count);
        } else {
          badges.forEach((badge) => {
            badge.textContent = String(count);
          });
        }
        const sr = cart.querySelector('.visually-hidden');
        if (sr) {
          const template = cart.getAttribute('data-cart-count-label') || '__COUNT__ items in cart';
          sr.textContent = template.replace('__COUNT__', String(count));
        } else {
          const label = document.createElement('span');
          label.className = 'visually-hidden';
          const template = cart.getAttribute('data-cart-count-label') || '__COUNT__ items in cart';
          label.textContent = template.replace('__COUNT__', String(count));
          cart.appendChild(label);
        }
      } else {
        badges.forEach((badge) => badge.remove());
        const sr = cart.querySelector('.visually-hidden');
        if (sr) sr.remove();
      }
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  // Shared helper for quick-add / non-drawer callers (scopes to .header__cart).
  window.__updateHeaderCartCount = function (count) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.updateHeaderCount === 'function') {
      drawer.updateHeaderCount(count);
      return;
    }
    const cart = document.querySelector('.header__cart');
    if (!cart) return;
    const badges = cart.querySelectorAll('[data-cart-count], .header__cart-count');
    if (count > 0) {
      if (!badges.length) {
        const badge = document.createElement('span');
        badge.className = 'header__cart-count';
        badge.setAttribute('data-cart-count', '');
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = String(count);
        cart.appendChild(badge);
      } else {
        badges.forEach((badge) => {
          badge.textContent = String(count);
        });
      }
    } else {
      badges.forEach((badge) => badge.remove());
    }
  };

  // Header badge count before an add (0 when badge is absent = empty cart).
  window.__getHeaderCartCount = function () {
    const badge = document.querySelector('.header__cart [data-cart-count], .header__cart .header__cart-count');
    if (!badge) return 0;
    return parseInt(badge.textContent, 10) || 0;
  };

  // Normalize /cart/add.js response (single line item or { items: [...] }).
  window.__cartAddItemFromResponse = function (data) {
    if (!data || typeof data !== 'object') return { image: '', title: '', quantity: 1 };
    const lines = Array.isArray(data.items) ? data.items : [data];
    const line = lines[0] || {};
    let quantity = 0;
    lines.forEach((item) => {
      if (item && typeof item.quantity === 'number') quantity += item.quantity;
    });
    if (!quantity) quantity = 1;
    const featured = line.featured_image;
    let image =
      (featured && (featured.url || featured.src)) ||
      (typeof line.image === 'string' ? line.image : '') ||
      '';
    if (image) {
      try {
        const absolute = image.indexOf('//') === 0 ? 'https:' + image : image;
        const parsed = new URL(absolute);
        parsed.searchParams.set('width', '144');
        parsed.searchParams.set('height', '144');
        parsed.searchParams.set('crop', 'center');
        image = parsed.toString();
      } catch (e) {
        /* keep original url */
      }
    }
    const title = line.product_title || line.title || '';
    return { image, title, quantity };
  };

  // After a successful add: update badge, then open drawer (first item) or show toast.
  window.__afterCartAdd = function ({ wasEmpty, cart, item, skipFeedback }) {
    if (cart && typeof cart.item_count === 'number') {
      window.__updateHeaderCartCount(cart.item_count);
    }
    if (skipFeedback) return;
    if (wasEmpty) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      return;
    }
    if (window.__cartAddNotification && typeof window.__cartAddNotification.show === 'function') {
      window.__cartAddNotification.show(item || {});
    }
  };

  // Open the drawer from the header cart icon (progressive enhancement over the /cart link).
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-cart-drawer-toggle]');
    if (!toggle) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    event.preventDefault();
    drawer.open();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('cart-drawer.is-open');
    if (open) open.close();
  });

  // Intercept add-to-cart forms: first item opens drawer; subsequent adds show toast.
  let cartAdding = false;
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return; // no drawer -> let the form submit normally
    event.preventDefault();
    if (cartAdding) return;
    cartAdding = true;

    const wasEmpty = window.__getHeaderCartCount() === 0;
    const formData = new FormData(form);
    formData.append('sections', drawer.sectionId);
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');
    const fallbackError = drawer.dataset.errorAdd || 'Could not add to cart.';

    try {
      const addUrl = (drawer.dataset.cartAddUrl || '/cart/add') + '.js';
      const res = await fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
      const data = await res.json();
      if (!res.ok) {
        drawer.showError(data.description || data.message || fallbackError);
        drawer.open();
        return;
      }
      if (data.sections && data.sections[drawer.sectionId]) {
        drawer.replaceContents(data.sections[drawer.sectionId]);
      }
      const cart = await (await fetch((drawer.dataset.cartUrl || '/cart') + '.js')).json();
      window.__afterCartAdd({
        wasEmpty,
        cart,
        item: window.__cartAddItemFromResponse(data),
      });
    } catch (e) {
      drawer.showError(fallbackError);
      drawer.open();
    } finally {
      if (submitBtn) submitBtn.removeAttribute('aria-busy');
      cartAdding = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.loading = false;
      this.bind();
    }

    bind() {
      this.querySelectorAll('[data-qty-change]').forEach((btn) =>
        btn.addEventListener('click', () => this.changeQuantity(btn))
      );
      const applyBtn = this.querySelector('[data-discount-apply]');
      if (applyBtn) applyBtn.addEventListener('click', () => this.applyDiscount());
      const input = this.querySelector('[data-discount-input]');
      if (input) {
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.applyDiscount();
          }
        });
      }
      this.bindCarousel();
    }

    async changeQuantity(btn) {
      if (this.loading) return;
      const line = btn.closest('[data-cart-line]');
      if (!line) return;
      const key = line.dataset.key;
      const quantity = parseInt(btn.dataset.qtyChange, 10);
      const fallbackError = this.dataset.errorUpdate || 'Could not update your cart.';
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      this.querySelectorAll('[data-qty-change]').forEach((b) => (b.disabled = true));

      try {
        const changeUrl = (this.dataset.cartChangeUrl || '/cart/change') + '.js';
        const res = await fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity, sections: this.sectionId }),
        });
        const data = await res.json();
        if (!res.ok) {
          this.showError(data.description || data.message || fallbackError);
          this.querySelectorAll('[data-qty-change]').forEach((b) => (b.disabled = false));
          return;
        }
        const html = data.sections && data.sections[this.sectionId];
        if (html) this.replaceContents(html);
        this.updateHeaderCount(data.item_count);
      } catch (e) {
        this.showError(fallbackError);
        this.querySelectorAll('[data-qty-change]').forEach((b) => (b.disabled = false));
      } finally {
        this.loading = false;
        this.removeAttribute('aria-busy');
      }
    }

    showError(message) {
      let banner = this.querySelector('.cart-page__error');
      if (!banner) {
        banner = document.createElement('p');
        banner.className = 'cart-page__error';
        banner.setAttribute('role', 'alert');
        const host = this.querySelector('.cart-page__inner') || this;
        host.prepend(banner);
      }
      banner.textContent = message;
      clearTimeout(this._errTimer);
      this._errTimer = setTimeout(() => banner && banner.remove(), 5000);
    }

    applyDiscount() {
      const input = this.querySelector('[data-discount-input]');
      if (!input) return;
      const code = input.value.trim();
      if (!code) return;
      const cartUrl = this.dataset.cartUrl || '/cart';
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);
    }

    replaceContents(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('cart-page');
      if (!fresh) return;
      this.innerHTML = fresh.innerHTML;
      this.setAttribute('data-just-replaced', '1');
      this.bind();
      if (window.Wishlist) window.Wishlist.reflect();
    }

    updateHeaderCount(count) {
      const cart = document.querySelector('.header__cart');
      if (!cart) return;

      // Scope to the cart icon — wishlist reuses .header__cart-count earlier in the header.
      const badges = cart.querySelectorAll('[data-cart-count], .header__cart-count');
      if (count > 0) {
        if (!badges.length) {
          const badge = document.createElement('span');
          badge.className = 'header__cart-count';
          badge.setAttribute('data-cart-count', '');
          badge.setAttribute('aria-hidden', 'true');
          cart.appendChild(badge);
          badge.textContent = String(count);
        } else {
          badges.forEach((badge) => {
            badge.textContent = String(count);
          });
        }
        const sr = cart.querySelector('.visually-hidden');
        if (sr) {
          const template = cart.getAttribute('data-cart-count-label') || '__COUNT__ items in cart';
          sr.textContent = template.replace('__COUNT__', String(count));
        } else {
          const label = document.createElement('span');
          label.className = 'visually-hidden';
          const template = cart.getAttribute('data-cart-count-label') || '__COUNT__ items in cart';
          label.textContent = template.replace('__COUNT__', String(count));
          cart.appendChild(label);
        }
      } else {
        badges.forEach((badge) => badge.remove());
        const sr = cart.querySelector('.visually-hidden');
        if (sr) sr.remove();
      }
    }

    bindCarousel() {
      const track = this.querySelector('[data-recs-track]');
      if (!track) return;
      const prev = this.querySelector('[data-recs-prev]');
      const next = this.querySelector('[data-recs-next]');
      const step = () => {
        const card = track.querySelector('.cart-recs__item');
        return card ? card.getBoundingClientRect().width + 16 : 296;
      };
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

      const sync = () => {
        const atStart = track.scrollLeft <= 1;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      };
      track.addEventListener('scroll', sync, { passive: true });
      sync();
    }
  }

  if (!customElements.get('cart-page')) {
    customElements.define('cart-page', CartPage);
  }

  // Refresh the cart page when quick-add (or other AJAX adds) update the cart
  // but did not already replace this section via the Cart API `sections` response.
  document.addEventListener('cart:updated', async (event) => {
    const page = document.querySelector('cart-page');
    if (!page || !page.sectionId || page._quickAddRefreshing) return;
    if (page.getAttribute('data-just-replaced') === '1') {
      page.removeAttribute('data-just-replaced');
      return;
    }
    page._quickAddRefreshing = true;
    try {
      const cartUrl = page.dataset.cartUrl || '/cart';
      const url = cartUrl + (cartUrl.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(page.sectionId);
      const res = await fetch(url);
      const data = await res.json();
      const html = data && data[page.sectionId];
      if (html && typeof page.replaceContents === 'function') {
        page.replaceContents(html);
      }
      const count =
        (event.detail && event.detail.item_count) ||
        (event.detail && event.detail.cart && event.detail.cart.item_count);
      if (typeof count === 'number' && typeof page.updateHeaderCount === 'function') {
        page.updateHeaderCount(count);
      }
    } catch (e) {
      /* leave current cart page markup */
    } finally {
      page._quickAddRefreshing = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-cards"] && !Shopify.designMode) return;
  try {
    
  class CategoryCards extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rail-track]');
      this.previousButton = this.querySelector('[data-rail-prev]');
      this.nextButton = this.querySelector('[data-rail-next]');

      if (!this.track) return;

      this.previousButton?.addEventListener('click', () => this.scroll(-1));
      this.nextButton?.addEventListener('click', () => this.scroll(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      window.addEventListener('resize', () => this.sync());
      this.sync();
    }

    scroll(direction) {
      const item = this.track.querySelector('[data-rail-item]');
      const distance = item ? item.getBoundingClientRect().width + 10 : this.track.clientWidth;
      this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    sync() {
      const scrollable = this.track.scrollWidth > this.track.clientWidth + 1;
      if (this.previousButton) {
        this.previousButton.disabled = !scrollable || this.track.scrollLeft <= 1;
      }
      if (this.nextButton) {
        this.nextButton.disabled =
          !scrollable || this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
      }
    }
  }

  if (!customElements.get('category-cards')) {
    customElements.define('category-cards', CategoryCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-landing-header"] && !Shopify.designMode) return;
  try {
    
  class CollectionLandingHeader extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-sub-rail]');
      this.prevBtn = this.querySelector('[data-sub-prev]');
      this.nextBtn = this.querySelector('[data-sub-next]');

      if (!this.rail) return;

      this.prevBtn?.addEventListener('click', () => this.scrollRail(-1));
      this.nextBtn?.addEventListener('click', () => this.scrollRail(1));
      this.rail.addEventListener('scroll', () => this.syncRail(), { passive: true });
      window.addEventListener('resize', () => this.syncRail());
      this.syncRail();
    }

    railStep() {
      const item = this.rail.querySelector('.col-land-sub');
      if (!item) return 200;
      const gap = parseFloat(getComputedStyle(this.rail).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    scrollRail(dir) {
      this.rail.scrollBy({ left: dir * this.railStep(), behavior: 'smooth' });
    }

    syncRail() {
      if (this.prevBtn) this.prevBtn.disabled = this.rail.scrollLeft <= 1;
      if (this.nextBtn) {
        this.nextBtn.disabled =
          this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 1;
      }
    }
  }

  if (!customElements.get('collection-landing-header')) {
    customElements.define('collection-landing-header', CollectionLandingHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.grid = this.querySelector('[data-product-grid]');
      this.moreWrap = this.querySelector('[data-load-more-wrap]');
      this.moreBtn = this.querySelector('[data-load-more]');
      this.sentinel = this.querySelector('[data-load-sentinel]');
      this.showing = this.querySelector('[data-showing-label]');
      this.isLoading = false;
      this.rail = this.querySelector('[data-sub-rail]');
      this.sidebar = this.querySelector('[data-filters-panel]');
      this.backdrop = this.querySelector('[data-filters-backdrop]');

      this.facetsForm = this.querySelector('[data-collection-facets]');
      this.pendingFilters = false;

      this.querySelectorAll('[data-collection-facets]').forEach((form) => {
        form.addEventListener('change', (e) => {
          if (e.target.closest('[data-facet-more]')) return;
          // In the mobile drawer, changes are batched until "View" is pressed.
          if (this.isDrawerOpen()) {
            this.pendingFilters = true;
            return;
          }
          this.submitFilters(form);
        });
        form.querySelectorAll('[data-facet-more]').forEach((btn) =>
          btn.addEventListener('click', () => this.expandFacet(btn))
        );
      });

      if (this.moreBtn) this.moreBtn.addEventListener('click', () => this.loadMore());
      this.initInfiniteScroll();

      this.querySelector('[data-sub-prev]')?.addEventListener('click', () => this.scrollRail(-1));
      this.querySelector('[data-sub-next]')?.addEventListener('click', () => this.scrollRail(1));

      this.querySelectorAll('[data-filters-open]').forEach((btn) =>
        btn.addEventListener('click', () => this.openFilters(btn.dataset.filtersFocus))
      );
      this.querySelectorAll('[data-filters-close]').forEach((btn) =>
        btn.addEventListener('click', () => this.applyAndClose())
      );
      this.backdrop?.addEventListener('click', () => this.applyAndClose());

      this.onKeydown = (e) => {
        if (e.key === 'Escape' && this.isDrawerOpen()) this.closeFilters();
      };
      document.addEventListener('keydown', this.onKeydown);

      this.initSmartStickyControls();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('scroll', this.onControlsScroll);
      window.removeEventListener('resize', this.measureControlsAnchor);
      this.controlsMq?.removeEventListener('change', this.onControlsMqChange);
      this.controlsResizeObserver?.disconnect();
      this.loadObserver?.disconnect();
      document.documentElement.style.overflow = '';
    }

    initInfiniteScroll() {
      if (!this.sentinel || typeof IntersectionObserver === 'undefined') return;

      this.loadObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry?.isIntersecting) return;
          if (this.isLoading || !this.moreBtn?.dataset.nextUrl) return;
          this.loadMore();
        },
        { rootMargin: '320px 0px 0px' }
      );

      this.loadObserver.observe(this.sentinel);
    }

    setLoadMoreState({ nextUrl, shown, total, page }) {
      if (shown != null && this.grid) this.grid.dataset.shown = shown;
      if (total != null && this.grid) this.grid.dataset.total = total;
      if (page != null && this.grid) this.grid.dataset.page = page;

      if (nextUrl && this.moreBtn) {
        this.moreBtn.dataset.nextUrl = nextUrl;
        this.moreBtn.disabled = false;
        if (this.moreWrap) this.moreWrap.hidden = false;
        if (this.sentinel) this.sentinel.hidden = false;
        return;
      }

      if (this.moreBtn) {
        delete this.moreBtn.dataset.nextUrl;
        this.moreBtn.disabled = true;
      }
      if (this.moreWrap) this.moreWrap.hidden = true;
      if (this.sentinel) {
        this.sentinel.hidden = true;
        this.loadObserver?.unobserve(this.sentinel);
      }
    }

    initSmartStickyControls() {
      this.controls = this.querySelector('[data-smart-sticky-controls]');
      this.controlsAnchor = this.querySelector('[data-controls-anchor]');
      if (!this.controls || !this.controlsAnchor) return;

      this.controlsMq = window.matchMedia('(max-width: 989px)');
      this.controlsLastY = window.scrollY || 0;
      this.controlsTicking = false;
      this.controlsAnchorY = 0;

      this.measureControlsAnchor = () => {
        if (!this.controlsMq.matches) return;
        const headerOffset =
          parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-offset')) || 72;
        this.controlsAnchorY =
          this.controlsAnchor.getBoundingClientRect().top + window.scrollY - headerOffset;
      };

      this.updateControlsSticky = () => {
        this.controlsTicking = false;
        if (!this.controlsMq.matches) {
          this.controls.classList.remove('is-hidden', 'is-scrolled');
          return;
        }

        const y = window.scrollY || document.documentElement.scrollTop || 0;
        const delta = 6;
        const goingDown = y > this.controlsLastY + delta;
        const goingUp = y < this.controlsLastY - delta;
        const pastControls = y > this.controlsAnchorY + 8;

        this.controls.classList.toggle('is-scrolled', pastControls);

        if (y <= 8 || this.isDrawerOpen()) {
          this.controls.classList.remove('is-hidden');
        } else if (goingDown && pastControls) {
          this.controls.classList.add('is-hidden');
        } else if (goingUp) {
          this.controls.classList.remove('is-hidden');
        }

        this.controlsLastY = y;
      };

      this.onControlsScroll = () => {
        if (!this.controlsTicking) {
          this.controlsTicking = true;
          requestAnimationFrame(() => this.updateControlsSticky());
        }
      };

      this.onControlsMqChange = () => {
        this.measureControlsAnchor();
        this.updateControlsSticky();
      };

      window.addEventListener('scroll', this.onControlsScroll, { passive: true });
      window.addEventListener('resize', this.measureControlsAnchor, { passive: true });
      this.controlsMq.addEventListener('change', this.onControlsMqChange);

      if (typeof ResizeObserver !== 'undefined') {
        this.controlsResizeObserver = new ResizeObserver(() => this.measureControlsAnchor());
        this.controlsResizeObserver.observe(this.controls);
      }

      this.measureControlsAnchor();
      this.updateControlsSticky();
    }

    submitFilters(form) {
      const data = new FormData(form);
      const params = new URLSearchParams();
      for (const [key, value] of data.entries()) {
        if (value !== '') params.append(key, value);
      }
      const url = form.action + (params.toString() ? '?' + params.toString() : '');
      window.location.href = url;
    }

    expandFacet(btn) {
      const list = btn.previousElementSibling;
      if (!list) return;
      list.querySelectorAll('[data-facet-extra]').forEach((li) => li.removeAttribute('hidden'));
      btn.hidden = true;
    }

    scrollRail(dir) {
      if (!this.rail) return;
      this.rail.scrollBy({ left: dir * 200, behavior: 'smooth' });
    }

    isDrawerOpen() {
      return Boolean(this.sidebar && this.sidebar.classList.contains('is-open'));
    }

    openFilters(focus) {
      if (!this.sidebar) return;
      this.pendingFilters = false;
      this.sidebar.classList.add('is-open');
      if (this.backdrop) this.backdrop.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      this.controls?.classList.remove('is-hidden');

      this.setFacetAccordionState(focus);

      this.querySelector('[data-filters-close]')?.focus();
    }

    setFacetAccordionState(focus) {
      const sort = this.querySelector('[data-facet-sort]');
      const filterGroups = this.querySelectorAll('.col-facets__group:not([data-facet-sort])');
      const body = this.querySelector('[data-filters-body]');

      if (focus === 'sort') {
        if (sort) sort.open = true;
        filterGroups.forEach((group) => {
          group.open = false;
        });
        sort?.scrollIntoView({ block: 'nearest' });
        if (body) body.scrollTop = 0;
        return;
      }

      if (sort) sort.open = false;

      let openedAny = false;
      filterGroups.forEach((group) => {
        const hasChecked = group.querySelector('input:checked');
        const hasPrice = Array.from(group.querySelectorAll('.col-facets__price input')).some(
          (input) => input.value.trim() !== ''
        );
        group.open = Boolean(hasChecked || hasPrice);
        if (group.open) openedAny = true;
      });

      if (!openedAny && filterGroups.length > 0) {
        filterGroups[0].open = true;
      }

      filterGroups[0]?.scrollIntoView({ block: 'nearest' });
      if (body) body.scrollTop = 0;
    }

    closeFilters() {
      this.sidebar?.classList.remove('is-open');
      if (this.backdrop) this.backdrop.hidden = true;
      document.documentElement.style.overflow = '';
    }

    applyAndClose() {
      if (this.pendingFilters && this.facetsForm) {
        this.submitFilters(this.facetsForm);
        return;
      }
      this.closeFilters();
    }

    async loadMore() {
      if (this.isLoading || !this.moreBtn || !this.grid) return;
      const nextUrl = this.moreBtn.dataset.nextUrl;
      if (!nextUrl) return;

      this.isLoading = true;
      this.moreBtn.disabled = true;
      this.grid.setAttribute('aria-busy', 'true');

      try {
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);
        const res = await fetch(url.toString(), { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Failed');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.querySelector('[data-product-grid]');
        const nextMore = doc.querySelector('[data-load-more]');
        const nextShowing = doc.querySelector('[data-showing-label]');

        if (nextGrid) {
          nextGrid.querySelectorAll('[data-col-item]').forEach((item) => {
            this.grid.appendChild(item);
          });
        }

        if (nextShowing && this.showing) this.showing.textContent = nextShowing.textContent;

        this.setLoadMoreState({
          nextUrl: nextMore?.dataset.nextUrl,
          shown: nextGrid?.dataset.shown,
          total: nextGrid?.dataset.total,
          page: nextGrid?.dataset.page,
        });
      } catch (e) {
        this.moreBtn.disabled = false;
      } finally {
        this.isLoading = false;
        this.grid.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('collection-page')) {
    customElements.define('collection-page', CollectionPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.contactReady === 'true') return;
      root.dataset.contactReady = 'true';

      var successEl = root.querySelector('[data-contact-success]');
      if (successEl) successEl.focus();
    }

    document.querySelectorAll('[data-contact-form]').forEach(init);

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-contact-form]');
      if (root) {
        root.dataset.contactReady = 'false';
        init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-locations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 350;
    var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function supportsDetailsContent() {
      return CSS.supports('selector(::details-content)');
    }

    function animateOpen(details, panel) {
      details.open = true;
      panel.style.overflow = 'hidden';
      panel.style.height = '0px';
      panel.style.opacity = '0';
      panel.offsetHeight;
      panel.style.transition = 'height ' + DURATION + 'ms ' + EASING + ', opacity 250ms ease';
      panel.style.height = panel.scrollHeight + 'px';
      panel.style.opacity = '1';

      function onEnd(event) {
        if (event.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', onEnd);
        panel.style.height = '';
        panel.style.overflow = '';
        panel.style.opacity = '';
        panel.style.transition = '';
      }

      panel.addEventListener('transitionend', onEnd);
    }

    function animateClose(details, panel) {
      panel.style.overflow = 'hidden';
      panel.style.height = panel.scrollHeight + 'px';
      panel.style.opacity = '1';
      panel.offsetHeight;
      panel.style.transition = 'height ' + DURATION + 'ms ' + EASING + ', opacity 250ms ease';
      panel.style.height = '0px';
      panel.style.opacity = '0';

      function onEnd(event) {
        if (event.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', onEnd);
        details.open = false;
        panel.style.height = '';
        panel.style.overflow = '';
        panel.style.opacity = '';
        panel.style.transition = '';
      }

      panel.addEventListener('transitionend', onEnd);
    }

    function initItem(details) {
      if (!details || details.dataset.contactAccordionReady === 'true') return;
      details.dataset.contactAccordionReady = 'true';

      var summary = details.querySelector('.contact-locations__summary');
      var panel = details.querySelector('.contact-locations__panel');
      if (!summary || !panel) return;

      summary.addEventListener('click', function (event) {
        if (prefersReducedMotion() || supportsDetailsContent()) return;

        event.preventDefault();
        if (details.open) {
          animateClose(details, panel);
        } else {
          animateOpen(details, panel);
        }
      });
    }

    function init(root) {
      var scope = root || document;
      scope.querySelectorAll('.contact-locations__item').forEach(initItem);
    }

    init();

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-article-cards"] && !Shopify.designMode) return;
  try {
    
  class FeaturedArticleCards extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-articles-track]');
      this.previousButton = this.querySelector('[data-articles-prev]');
      this.nextButton = this.querySelector('[data-articles-next]');

      if (!this.track) return;

      this.previousButton?.addEventListener('click', () => this.scroll(-1));
      this.nextButton?.addEventListener('click', () => this.scroll(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      window.addEventListener('resize', () => this.sync());
      this.sync();
    }

    scroll(direction) {
      const item = this.track.querySelector('[data-articles-item]');
      const distance = item ? item.getBoundingClientRect().width + 12 : this.track.clientWidth;
      this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    sync() {
      if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 1;
      if (this.nextButton) {
        this.nextButton.disabled =
          this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
      }
    }
  }

  if (!customElements.get('featured-article-cards')) {
    customElements.define('featured-article-cards', FeaturedArticleCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-rail"] && !Shopify.designMode) return;
  try {
    
  class FeaturedProductsRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-products-track]');
      this.previousButton = this.querySelector('[data-products-prev]');
      this.nextButton = this.querySelector('[data-products-next]');

      if (!this.track) return;

      this.previousButton?.addEventListener('click', () => this.scroll(-1));
      this.nextButton?.addEventListener('click', () => this.scroll(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      window.addEventListener('resize', () => this.sync());
      this.sync();
    }

    scroll(direction) {
      const item = this.track.querySelector('[data-products-item]');
      const distance = item ? item.getBoundingClientRect().width + 12 : this.track.clientWidth;
      this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    sync() {
      if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 1;
      if (this.nextButton) {
        this.nextButton.disabled =
          this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
      }
    }
  }

  if (!customElements.get('featured-products-rail')) {
    customElements.define('featured-products-rail', FeaturedProductsRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["financing-calculator"] && !Shopify.designMode) return;
  try {
    
  class FinancingCalculatorModal extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      this.openButton = this.querySelector('[data-calculator-open]');
      this.closeButton = this.querySelector('[data-calculator-close]');
      this.dialog = this.querySelector('[data-calculator-dialog]');
      this.iframe = this.querySelector('[data-calculator-iframe]');

      if (!this.dialog) return;

      if (this.openButton) {
        this.openButton.addEventListener('click', () => this.open());
      }

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });

      this.dialog.addEventListener('close', () => this.onClose());
    }

    calculatorSrc(layout) {
      const params = new URLSearchParams({
        lease: 'true',
        rental: 'true',
        loan: 'true',
        init: 'lease',
        lang: 'en-ca',
        color: 'd51e35',
        'pricing-breakdown': 'true',
        apply: 'false',
        layout: layout,
        logo: 'https://cdn.prod.website-files.com/6793c58263dab0a63ce54435/67b3a8b061ff1d1f42b8d137_bigerics_logo.png',
      });

      return 'https://apps.econolease.com/calculator/efscalculator?' + params.toString();
    }

    layoutForViewport() {
      if (window.matchMedia('(min-width: 1024px)').matches) return 'horizontal';
      return 'vertical';
    }

    loadCalculator() {
      if (!this.iframe) return;

      const layout = this.layoutForViewport();
      const src = this.calculatorSrc(layout);

      if (this.iframe.getAttribute('src') === src) return;

      this.iframe.setAttribute('src', src);
    }

    open() {
      this.loadCalculator();
      this.dialog.showModal();
      if (this.openButton) this.openButton.setAttribute('aria-expanded', 'true');
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    onClose() {
      if (this.openButton) {
        this.openButton.setAttribute('aria-expanded', 'false');
        this.openButton.focus();
      }
    }
  }

  if (!customElements.get('financing-calculator-modal')) {
    customElements.define('financing-calculator-modal', FinancingCalculatorModal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["financing-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Affirm.js attaches its own click handler to `.affirm-site-modal` elements.
    // This only covers the case where Affirm.js is absent (no public API key, or
    // the script is blocked), so the CTA falls back to its configured link.
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-affirm-modal-button]');
      if (!button) return;

      if (window.affirm && window.affirm.ui) return;

      var fallback = button.getAttribute('data-affirm-fallback-url');
      if (fallback) window.location.href = fallback;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cookie-preferences]');
    if (!trigger) return;

    event.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card"]) return;
  try {
    
  class GiftCardProduct extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.giftcard__form');
      this.priceEl = this.querySelector('[data-giftcard-price]');
      this.atc = this.querySelector('[data-giftcard-atc]');
      this.stage = this.querySelector('.giftcard__stage img');
      this.emailInput = this.querySelector('[data-giftcard-recipient-email]');
      this.messageInput = this.querySelector('[data-giftcard-message]');
      this.emailError = this.querySelector('[data-giftcard-email-error]');
      this.messageError = this.querySelector('[data-giftcard-message-error]');
      this.errors = {
        emailRequired: this.dataset.errorEmailRequired || 'Recipient email is required',
        emailInvalid: this.dataset.errorEmailInvalid || 'Enter a valid email address',
        messageLength: this.dataset.errorMessageLength || 'Message is too long',
      };
      this.bindAmounts();
      this.bindQty();
      this.bindRecipient();
      this.bindGallery();
      this.bindValidation();
      this.syncAtcState();
    }

    isVariantAvailable() {
      return this.atc?.dataset.variantAvailable === 'true';
    }

    isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    validateEmail(showError = true) {
      if (!this.emailInput) return true;
      const value = this.emailInput.value.trim();
      let message = '';

      if (value === '') {
        message = this.errors.emailRequired;
      } else if (!this.isValidEmail(value)) {
        message = this.errors.emailInvalid;
      }

      if (showError) this.setFieldError(this.emailInput, this.emailError, message);
      return message === '';
    }

    validateMessage(showError = true) {
      if (!this.messageInput) return true;
      const value = this.messageInput.value;
      const max = Number(this.messageInput.getAttribute('maxlength') || 200);
      const message = value.length > max ? this.errors.messageLength : '';

      if (showError) this.setFieldError(this.messageInput, this.messageError, message);
      return message === '';
    }

    isFormValid() {
      return this.validateEmail(false) && this.validateMessage(false);
    }

    setFieldError(input, errorEl, message) {
      if (!input || !errorEl) return;
      const hasError = message !== '';
      input.classList.toggle('giftcard__input--error', hasError);
      input.setAttribute('aria-invalid', hasError ? 'true' : 'false');
      errorEl.textContent = message;
      errorEl.hidden = !hasError;
    }

    syncAtcState() {
      if (!this.atc) return;
      if (!this.isVariantAvailable()) {
        this.atc.disabled = true;
        this.atc.textContent = this.atc.dataset.labelSoldOut;
        return;
      }
      const valid = this.isFormValid();
      this.atc.disabled = !valid;
      this.atc.textContent = this.atc.dataset.labelAvailable;
    }

    bindValidation() {
      if (!this.form) return;

      const sync = () => this.syncAtcState();

      if (this.emailInput) {
        this.emailInput.addEventListener('input', sync);
        this.emailInput.addEventListener('blur', () => this.validateEmail(true));
      }

      if (this.messageInput) {
        this.messageInput.addEventListener('input', sync);
        this.messageInput.addEventListener('blur', () => this.validateMessage(true));
      }

      this.form.addEventListener('submit', (event) => {
        if (!this.isVariantAvailable()) {
          event.preventDefault();
          return;
        }

        if (this.emailInput) this.emailInput.value = this.emailInput.value.trim();

        const emailValid = this.validateEmail(true);
        const messageValid = this.validateMessage(true);

        if (!emailValid || !messageValid) {
          event.preventDefault();
          event.stopPropagation();
          if (!emailValid && this.emailInput) this.emailInput.focus();
          this.syncAtcState();
        }
      });
    }

    bindAmounts() {
      this.querySelectorAll('.giftcard__amount-input').forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          if (this.priceEl && input.dataset.price) this.priceEl.textContent = input.dataset.price;
          this.syncAtcState();
        });
      });
    }

    bindQty() {
      this.querySelectorAll('[data-qty]').forEach((wrap) => {
        const input = wrap.querySelector('[data-qty-input]');
        const minus = wrap.querySelector('[data-qty-minus]');
        const plus = wrap.querySelector('[data-qty-plus]');
        if (!input) return;
        const set = (n) => {
          input.value = Math.max(1, n);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        };
        if (minus) minus.addEventListener('click', () => set(parseInt(input.value || '1', 10) - 1));
        if (plus) plus.addEventListener('click', () => set(parseInt(input.value || '1', 10) + 1));
      });
    }

    bindRecipient() {
      const control = this.querySelector('[data-giftcard-send-control]');
      const email = this.emailInput;
      if (!control || !email) return;
      const sync = () => {
        control.value = email.value.trim() === '' ? '' : 'on';
      };
      email.addEventListener('input', sync);
      sync();
    }

    bindGallery() {
      this.querySelectorAll('.giftcard__thumb').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!this.stage || !thumb.dataset.mediaSrc) return;
          this.querySelectorAll('.giftcard__thumb').forEach((t) => t.classList.toggle('is-active', t === thumb));
          this.stage.srcset = '';
          this.stage.src = thumb.dataset.mediaSrc;
        });
      });
    }
  }

  if (!customElements.get('gift-card-product')) customElements.define('gift-card-product', GiftCardProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-menu-drawer]').forEach((drawer) => {
    const root = drawer.querySelector('[data-level-root]');
    const levels = drawer.querySelectorAll('.drawer-level');

    const showLevel = (el) => {
      if (!el) return;
      levels.forEach((level) => level.classList.remove('is-active'));
      el.classList.add('is-active');
    };

    const close = () => drawer.removeAttribute('open');

    drawer.querySelectorAll('[data-drawer-close]').forEach((el) => {
      el.addEventListener('click', close);
    });

    drawer.querySelectorAll('[data-open-sub]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = drawer.querySelector('[data-level="' + btn.dataset.openSub + '"]');
        showLevel(target);
      });
    });

    drawer.querySelectorAll('[data-close-sub]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const parentId = btn.dataset.parentLevel;
        if (!parentId || parentId === 'root') {
          showLevel(root);
          return;
        }
        showLevel(drawer.querySelector('[data-level="' + parentId + '"]'));
      });
    });

    drawer.addEventListener('toggle', () => {
      if (!drawer.open) showLevel(root);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.hasAttribute('open')) close();
    });
  });

  (function fitHeaderNav() {
    const mainInner = document.querySelector('.header__main-inner');
    const nav = document.querySelector('.header__nav');
    const list = nav?.querySelector('.header__nav-list');
    if (!mainInner || !nav || !list) return;

    const desktopNav = window.matchMedia('(min-width: 990px)');

    const fit = () => {
      const items = [...list.querySelectorAll('.header__nav-item')];
      items.forEach((item) => item.classList.remove('is-nav-hidden'));

      if (!desktopNav.matches) {
        nav.style.removeProperty('max-width');
        return;
      }

      const left = mainInner.querySelector('.header__left');
      const actions = mainInner.querySelector('.header__actions');
      const styles = getComputedStyle(mainInner);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const sideWidth = Math.max(left?.offsetWidth || 0, actions?.offsetWidth || 0);
      const maxNavWidth = Math.max(0, mainInner.clientWidth - sideWidth * 2 - gap * 2);
      nav.style.maxWidth = `${maxNavWidth}px`;

      for (let index = items.length - 1; index >= 0; index -= 1) {
        if (list.scrollWidth <= nav.clientWidth) break;
        items[index].classList.add('is-nav-hidden');
      }
    };

    fit();
    window.addEventListener('resize', fit, { passive: true });
    desktopNav.addEventListener('change', fit);
    if (document.fonts?.ready) {
      document.fonts.ready.then(fit);
    }
  })();

  document.querySelectorAll('.header__nav-item--mega').forEach((item) => {
    const trigger = item.querySelector('.header__nav-link');
    const panel = item.querySelector('[data-mega-menu]');
    if (!trigger || !panel) return;

    const unlock = () => {
      delete item.dataset.megaLocked;
    };

    const open = () => {
      if (item.dataset.megaLocked === 'true') return;

      document.querySelectorAll('.header__nav-item--mega.is-open').forEach((openItem) => {
        if (openItem === item) return;
        openItem.classList.remove('is-open');
        const openTrigger = openItem.querySelector('.header__nav-link');
        if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
      });

      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    };

    item.addEventListener('mouseenter', () => {
      unlock();
      open();
    });

    item.addEventListener('mouseleave', () => {
      unlock();
      close();
    });

    item.addEventListener('focusin', open);

    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) {
        unlock();
        close();
      }
    });

    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !item.classList.contains('is-open')) return;
      event.preventDefault();
      item.dataset.megaLocked = 'true';
      close();
      trigger.focus();
    });
  });

  (function smartStickyHeader() {
    const header = document.querySelector('[data-smart-sticky]');
    if (!header) return;

    const shell =
      header.closest('.shopify-section-group-header-group') ||
      header.closest('.shopify-section-group') ||
      header.closest('.shopify-section') ||
      header;

    shell.classList.add('header-shell--sticky');

    let lastY = window.scrollY || 0;
    let ticking = false;
    const delta = 6;

    const setHeaderOffset = () => {
      const visible = !shell.classList.contains('is-hidden');
      document.documentElement.style.setProperty(
        '--header-offset',
        visible ? `${shell.offsetHeight}px` : '0px'
      );
    };

    const isLockedOpen = () => {
      if (header.querySelector('[data-menu-drawer][open]')) return true;
      if (header.querySelector('details.search[open], details.menu-drawer[open]')) return true;
      if (header.querySelector('.header__nav-item--mega.is-open')) return true;
      return false;
    };

    const update = () => {
      ticking = false;
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      const goingDown = y > lastY + delta;
      const goingUp = y < lastY - delta;
      const pastHeader = y > Math.max(shell.offsetHeight, 80);

      shell.classList.toggle('is-scrolled', y > 4);

      if (y <= 8 || isLockedOpen()) {
        shell.classList.remove('is-hidden');
      } else if (goingDown && pastHeader) {
        shell.classList.add('is-hidden');
      } else if (goingUp) {
        shell.classList.remove('is-hidden');
      }

      setHeaderOffset();
      lastY = y;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', setHeaderOffset, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(setHeaderOffset).observe(shell);
    }
    setHeaderOffset();
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-hero-track]');
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this.index = 0;
      if (this.slides.length < 2) return;

      this.dots.forEach((dot) =>
        dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.heroDot, 10), true))
      );

      this.querySelector('[data-hero-prev]')?.addEventListener('click', () => {
        this.goTo((this.index - 1 + this.slides.length) % this.slides.length, true);
      });
      this.querySelector('[data-hero-next]')?.addEventListener('click', () => {
        this.goTo((this.index + 1) % this.slides.length, true);
      });

      this.track.addEventListener('scroll', () => {
        const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (i !== this.index) this.setActive(i);
      }, { passive: true });

      if (this.dataset.autoplay === 'true') this.start();
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => { if (this.dataset.autoplay === 'true') this.start(); });
    }

    setActive(i) {
      this.index = i;
      this.dots.forEach((d, di) => d.classList.toggle('is-active', di === i));
    }

    goTo(i, user) {
      this.index = i;
      this.track.scrollTo({ left: this.track.clientWidth * i, behavior: 'smooth' });
      this.setActive(i);
      if (user) this.stop();
    }

    start() {
      this.stop();
      this._timer = setInterval(() => {
        const next = (this.index + 1) % this.slides.length;
        this.goTo(next);
      }, parseInt(this.dataset.interval, 10) || 5000);
    }

    stop() {
      if (this._timer) clearInterval(this._timer);
    }
  }

  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  class NewsletterPopup extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.ribbon = this.querySelector('[data-newsletter-ribbon]');
      this.dismissBtn = this.querySelector('[data-newsletter-dismiss]');
      this.panel = this.querySelector('.newsletter-popup__panel');
      this.form = this.querySelector('form');
      this.signupPage = this.querySelector('[data-newsletter-page="signup"]');
      this.codePage = this.querySelector('[data-newsletter-page="code"]');
      this.fields = this.querySelector('[data-newsletter-fields]');
      this.error = this.querySelector('[data-newsletter-error]');
      this.serverError = this.querySelector('[data-newsletter-server-error]');
      this.postedEl = this.querySelector('[data-newsletter-posted]');
      this.copyBtn = this.querySelector('[data-newsletter-copy]');

      this.subscribedKey = this.dataset.subscribedKey;
      this.dismissedKey = this.dataset.dismissedKey;
      this.designMode = Boolean(window.Shopify && window.Shopify.designMode);

      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
      };

      this.querySelectorAll('[data-newsletter-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      if (this.ribbon) {
        this.ribbon.addEventListener('click', () => this.toggle());
      }

      if (this.dismissBtn) {
        this.dismissBtn.addEventListener('click', () => this.dismiss());
      }

      if (this.form) {
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
      }

      if (this.copyBtn) {
        this.copyBtn.addEventListener('click', () => this.copyCode());
      }

      document.addEventListener('keydown', this.onKeydown);

      if (!this.designMode && (this.isSubscribed() || this.isDismissed())) {
        this.hidden = true;
        return;
      }

      this.setOpen(false);
      if (this.codePage) this.codePage.inert = true;

      if (this.postedEl && this.postedEl.dataset.newsletterPosted === 'true') {
        this.markSubscribed();
        this.showSuccess();
        this.open();
        return;
      }

      // Reached when the form posted without JS and Shopify rejected it.
      if (this.serverError) {
        this.open();
        return;
      }

      if (this.designMode) this.open();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      if (this._copyTimer) clearTimeout(this._copyTimer);
    }

    toggle() {
      if (this.classList.contains('is-open')) this.close();
      else this.open();
    }

    open() {
      this.setOpen(true);
      if (this.classList.contains('is-success') && this.copyBtn) {
        this.copyBtn.focus();
        return;
      }
      const field = this.querySelector('.newsletter-popup__input');
      if (field) field.focus();
    }

    close() {
      this.setOpen(false);
      if (!this.designMode && (this.isSubscribed() || this.isDismissed())) {
        this.hidden = true;
        return;
      }
      if (this.ribbon) this.ribbon.focus();
    }

    dismiss() {
      this.writeSession(this.dismissedKey, '1');
      this.hidden = true;
    }

    setOpen(isOpen) {
      this.classList.toggle('is-open', isOpen);
      if (this.ribbon) this.ribbon.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (this.panel) this.panel.inert = !isOpen;
    }

    showSuccess() {
      this.classList.add('is-success');
      if (this.signupPage) {
        this.signupPage.inert = true;
        this.signupPage.setAttribute('aria-hidden', 'true');
      }
      if (this.codePage) {
        this.codePage.inert = false;
        this.codePage.removeAttribute('aria-hidden');
      }
    }

    async copyCode() {
      if (!this.copyBtn) return;
      const code = this.copyBtn.dataset.code;
      if (!code) return;

      let copied = false;
      try {
        await navigator.clipboard.writeText(code);
        copied = true;
      } catch (e) {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'absolute';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();
        try {
          copied = document.execCommand('copy');
        } catch (err) {
          copied = false;
        }
        input.remove();
      }

      if (!copied) return;

      const idle = this.copyBtn.querySelector('[data-copy-idle]');
      const done = this.copyBtn.querySelector('[data-copy-done]');
      const copiedLabel = this.copyBtn.dataset.labelCopied || '';
      if (idle) idle.hidden = true;
      if (done) {
        done.hidden = true;
        void done.offsetWidth;
        done.hidden = false;
      }
      if (copiedLabel) this.copyBtn.setAttribute('aria-label', copiedLabel);

      if (this._copyTimer) clearTimeout(this._copyTimer);
      this._copyTimer = setTimeout(() => {
        const copyLabel = this.copyBtn.dataset.labelCopy || '';
        if (idle) idle.hidden = false;
        if (done) done.hidden = true;
        if (copyLabel) this.copyBtn.setAttribute('aria-label', copyLabel);
      }, 2000);
    }

    isSubscribed() {
      return this.read(this.subscribedKey) === '1';
    }

    isDismissed() {
      return this.readSession(this.dismissedKey) === '1';
    }

    markSubscribed() {
      this.write(this.subscribedKey, '1');
    }

    read(key) {
      if (!key) return null;
      try {
        return localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }

    write(key, value) {
      if (!key) return;
      try {
        localStorage.setItem(key, value);
      } catch (e) {}
    }

    readSession(key) {
      if (!key) return null;
      try {
        return sessionStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }

    writeSession(key, value) {
      if (!key) return;
      try {
        sessionStorage.setItem(key, value);
      } catch (e) {}
    }

    async onSubmit(event) {
      event.preventDefault();
      if (!this.form || this._submitting) return;

      const submitBtn = this.form.querySelector('[type="submit"]');
      this._submitting = true;
      this.hideError();
      if (submitBtn) submitBtn.disabled = true;

      try {
        await this.readyCaptcha();

        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
        });

        if (!response.ok) throw new Error('request rejected');
        if (!this.wasAccepted(response)) throw new Error('not subscribed');

        this.markSubscribed();
        this.showSuccess();
        if (this.copyBtn) this.copyBtn.focus();
      } catch (e) {
        this.showError();
      } finally {
        this._submitting = false;
        if (submitBtn) submitBtn.disabled = false;
      }
    }

    /* Shopify redirects back with this flag only once it has accepted the
       contact. Anything else has to count as a failure, otherwise a rejected
       submission still hands out a discount code. */
    wasAccepted(response) {
      if (!response.url) return false;
      return response.url.indexOf('customer_posted=true') !== -1;
    }

    /* Submissions carrying no CAPTCHA token are rejected outright, and the
       token only appears once Shopify has wired the form up. Resolve anyway
       after a timeout so a CAPTCHA that never loads cannot block signup. */
    readyCaptcha() {
      const captcha = window.Shopify && window.Shopify.captcha;
      if (!captcha || typeof captcha.protect !== 'function') return Promise.resolve();

      return new Promise((resolve) => {
        let settled = false;
        const done = () => {
          if (settled) return;
          settled = true;
          resolve();
        };

        setTimeout(done, 3000);
        try {
          captcha.protect(this.form, done);
        } catch (e) {
          done();
        }
      });
    }

    showError() {
      if (!this.error) return;
      this.error.hidden = false;
      this.error.textContent = this.error.dataset.fallback || '';
    }

    hideError() {
      if (!this.error) return;
      this.error.hidden = true;
      this.error.textContent = '';
    }
  }

  if (!customElements.get('newsletter-popup')) {
    customElements.define('newsletter-popup', NewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okendo-reviews"] && !Shopify.designMode) return;
  try {
    
  class OkendoAllReviews extends HTMLElement {
    connectedCallback() {
      this.subscriberId = this.dataset.subscriberId;
      if (!this.subscriberId) return;

      this.pageSize = parseInt(this.dataset.pageSize, 10) || 24;
      this.limit = this.pageSize;
      this.orderBy = 'date desc';
      this.total = null;

      this.summaryEl = this.querySelector('[data-summary]');
      this.averageEl = this.querySelector('[data-average]');
      this.averageStarsEl = this.querySelector('[data-average-stars]');
      this.countEl = this.querySelector('[data-count]');
      this.recommendEl = this.querySelector('[data-recommend]');
      this.levelsEl = this.querySelector('[data-levels]');
      this.toolbarEl = this.querySelector('[data-toolbar]');
      this.sortEl = this.querySelector('[data-sort]');
      this.loadingEl = this.querySelector('[data-loading]');
      this.listEl = this.querySelector('[data-list]');
      this.emptyEl = this.querySelector('[data-empty]');
      this.errorEl = this.querySelector('[data-error]');
      this.moreEl = this.querySelector('[data-more]');
      this.starTemplate = this.querySelector('[data-star]');

      if (this.sortEl) {
        this.sortEl.addEventListener('change', () => {
          this.orderBy = this.sortEl.value;
          this.limit = this.pageSize;
          this.load();
        });
      }

      const loadMore = this.querySelector('[data-load-more]');
      if (loadMore) {
        loadMore.addEventListener('click', () => {
          this.limit += this.pageSize;
          this.load({ keepList: true });
        });
      }

      const retry = this.querySelector('[data-retry]');
      if (retry) retry.addEventListener('click', () => this.load());

      this.load();
    }

    _api(path) {
      return 'https://api.okendo.io/v1/stores/' + encodeURIComponent(this.subscriberId) + '/' + path;
    }

    _fill(template, value) {
      return (template || '').replace('__N__', String(value));
    }

    async load(options) {
      const keepList = options && options.keepList;
      if (!keepList) {
        this.listEl.hidden = true;
        this.listEl.replaceChildren();
      }
      this.loadingEl.hidden = false;
      this.emptyEl.hidden = true;
      this.errorEl.hidden = true;
      this.moreEl.hidden = true;

      const reviewsUrl =
        this._api('reviews') +
        '?limit=' + encodeURIComponent(this.limit) +
        '&orderBy=' + encodeURIComponent(this.orderBy);

      try {
        // The aggregate is store-wide and cheap, so refresh it alongside the page.
        const [reviewsRes, aggregateRes] = await Promise.all([
          fetch(reviewsUrl),
          this.summaryEl ? fetch(this._api('review_aggregate')) : Promise.resolve(null),
        ]);

        if (!reviewsRes.ok) throw new Error('reviews ' + reviewsRes.status);
        const reviews = (await reviewsRes.json()).reviews || [];

        if (aggregateRes && aggregateRes.ok) {
          const aggregate = (await aggregateRes.json()).reviewAggregate;
          if (aggregate) this._renderSummary(aggregate);
        }

        this.loadingEl.hidden = true;
        this._renderList(reviews);
      } catch (error) {
        this.loadingEl.hidden = true;
        this.listEl.hidden = true;
        this.errorEl.hidden = false;
      }
    }

    _stars(rating) {
      const wrap = document.createElement('div');
      wrap.className = 'okendo-reviews__stars';
      wrap.setAttribute('role', 'img');
      wrap.setAttribute('aria-label', this._fill(this.dataset.strStars, rating));
      for (let i = 1; i <= 5; i += 1) {
        const star = this.starTemplate.content.cloneNode(true);
        const svg = star.querySelector('svg');
        if (svg && i <= Math.round(rating)) svg.setAttribute('data-on', '');
        wrap.appendChild(star);
      }
      return wrap;
    }

    _renderSummary(aggregate) {
      const count = aggregate.ratingAndReviewCount || 0;
      const totalValue = aggregate.ratingAndReviewValuesTotal || 0;
      this.total = count;
      if (!count) return;

      const average = totalValue / count;
      this.averageEl.textContent = average.toFixed(1);
      this.averageStarsEl.replaceChildren(this._stars(average));
      this.countEl.textContent = this._fill(
        count === 1 ? this.dataset.strCountOne : this.dataset.strCountOther,
        count
      );

      const recommends = aggregate.recommendationCount || 0;
      if (recommends > 0) {
        const pct = Math.round((recommends / count) * 100);
        this.recommendEl.textContent = this._fill(this.dataset.strRecommend, pct);
        this.recommendEl.hidden = false;
      }

      const byLevel = aggregate.ratingAndReviewCountByLevel || {};
      const rows = [];
      for (let level = 5; level >= 1; level -= 1) {
        const levelCount = byLevel['level' + level + 'Count'] || 0;
        const row = document.createElement('li');
        row.className = 'okendo-reviews__level';

        const label = document.createElement('span');
        label.textContent = this._fill(this.dataset.strLevel, level);

        const bar = document.createElement('span');
        bar.className = 'okendo-reviews__bar';
        const fill = document.createElement('span');
        fill.style.width = (count ? (levelCount / count) * 100 : 0) + '%';
        bar.appendChild(fill);

        const value = document.createElement('span');
        value.textContent = String(levelCount);

        row.append(label, bar, value);
        rows.push(row);
      }
      this.levelsEl.replaceChildren(...rows);
      this.summaryEl.hidden = false;
    }

    // Only same-origin product links and Shopify-hosted images are trusted; the
    // API's own productUrl is external input, so links are rebuilt from handle.
    _productImage(url) {
      if (!url) return null;
      try {
        const parsed = new URL(url, window.location.origin);
        if (parsed.protocol !== 'https:') return null;
        if (!/(^|\.)shopify\.com$/.test(parsed.hostname)) return null;
        return parsed.href;
      } catch (error) {
        return null;
      }
    }

    _renderList(reviews) {
      if (!reviews.length) {
        this.listEl.hidden = true;
        this.emptyEl.hidden = false;
        return;
      }

      const locale = document.documentElement.lang || undefined;
      const cards = reviews.map((review) => {
        const card = document.createElement('li');
        card.className = 'okendo-reviews__card';

        const top = document.createElement('div');
        top.className = 'okendo-reviews__card-top';
        top.appendChild(this._stars(review.rating || 0));
        if (review.title) {
          const title = document.createElement('h2');
          title.className = 'okendo-reviews__title';
          title.textContent = review.title;
          top.appendChild(title);
        }
        card.appendChild(top);

        if (review.body) {
          const body = document.createElement('p');
          body.className = 'okendo-reviews__body';
          body.textContent = review.body;
          card.appendChild(body);
        }

        const meta = document.createElement('div');
        meta.className = 'okendo-reviews__meta';
        const reviewer = review.reviewer || {};
        if (reviewer.displayName) {
          const who = document.createElement('span');
          who.textContent = reviewer.displayName;
          meta.appendChild(who);
        }
        if (reviewer.isVerified) {
          const verified = document.createElement('span');
          verified.textContent = this.dataset.strVerified;
          meta.appendChild(verified);
        }
        if (review.dateCreated) {
          const when = document.createElement('time');
          when.dateTime = review.dateCreated;
          when.textContent = new Date(review.dateCreated).toLocaleDateString(locale, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          });
          meta.appendChild(when);
        }
        if (meta.childElementCount) card.appendChild(meta);

        if (review.productName && review.productHandle) {
          const link = document.createElement('a');
          link.className = 'okendo-reviews__product';
          link.href = '/products/' + encodeURIComponent(review.productHandle);

          const image = this._productImage(review.productImageUrl);
          if (image) {
            const img = document.createElement('img');
            img.src = image;
            img.alt = '';
            img.loading = 'lazy';
            img.width = 48;
            img.height = 48;
            link.appendChild(img);
          }

          const name = document.createElement('span');
          name.textContent = review.productName;
          link.appendChild(name);
          card.appendChild(link);
        }

        return card;
      });

      this.listEl.replaceChildren(...cards);
      this.listEl.hidden = false;
      this.emptyEl.hidden = true;
      if (this.toolbarEl) this.toolbarEl.hidden = false;

      // `offset` is ignored by the API, so there is more to show only when the
      // aggregate total exceeds what this limit returned.
      const hasMore = this.total !== null && reviews.length < this.total;
      this.moreEl.hidden = !hasMore;
    }
  }

  if (!customElements.get('okendo-all-reviews')) {
    customElements.define('okendo-all-reviews', OkendoAllReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popcorn-calculator"] && !Shopify.designMode) return;
  try {
    
  class PopcornCalculator extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-popcorn-form]');
      this.errorEl = this.querySelector('[data-popcorn-error]');
      if (!this.form) return;

      this.currency = this.dataset.currency || 'CAD';
      this.locale = this.dataset.locale || 'en';
      this.requiredMessage = this.dataset.errorRequired || 'Enter a value above zero.';

      this._onSubmit = (event) => {
        event.preventDefault();
        this.calculate();
      };
      this.form.addEventListener('submit', this._onSubmit);
    }

    disconnectedCallback() {
      if (this.form && this._onSubmit) {
        this.form.removeEventListener('submit', this._onSubmit);
      }
    }

    field(name) {
      return this.querySelector(`[data-field="${name}"]`);
    }

    // Reads a field. Required fields must parse to a number above zero; the rest
    // fall back to `fallback` when left blank.
    read(name, fallback) {
      const input = this.field(name);
      if (!input) return fallback;

      const raw = input.value.trim();
      const value = raw === '' ? NaN : Number(raw);
      const required = input.hasAttribute('data-required');

      if (!Number.isFinite(value) || value < 0 || (required && value <= 0)) {
        if (required) return null;
        return fallback;
      }
      return value;
    }

    // Divisors come from theme settings, so guard against a zero that would
    // otherwise send every figure to Infinity.
    perServing(cost, servingsPerUnit) {
      const yieldPerUnit = Number(servingsPerUnit);
      if (!Number.isFinite(yieldPerUnit) || yieldPerUnit <= 0) return 0;
      return cost / yieldPerUnit;
    }

    money(value) {
      try {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency,
        }).format(value);
      } catch (error) {
        return `$${value.toFixed(2)}`;
      }
    }

    setResult(name, value) {
      const el = this.querySelector(`[data-result="${name}"]`);
      if (el) el.textContent = this.money(value);
    }

    showError(input) {
      this.querySelectorAll('[aria-invalid="true"]').forEach((el) => {
        el.removeAttribute('aria-invalid');
      });
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }
      if (this.errorEl) {
        this.errorEl.textContent = this.requiredMessage;
        this.errorEl.hidden = false;
      }
    }

    clearError() {
      this.querySelectorAll('[aria-invalid="true"]').forEach((el) => {
        el.removeAttribute('aria-invalid');
      });
      if (this.errorEl) this.errorEl.hidden = true;
    }

    calculate() {
      const required = [
        'retailPrice',
        'kernelCost',
        'oilCost',
        'seasoningCost',
        'bagBoxCost',
        'servingsPerDay',
        'daysPerWeek',
        'monthsPerYear',
      ];

      const values = {};
      for (const name of required) {
        const value = this.read(name);
        if (value === null) {
          this.showError(this.field(name));
          return;
        }
        values[name] = value;
      }
      this.clearError();

      const kernelQty = this.read('kernelQty', 1);
      const oilQty = this.read('oilQty', 1);
      const seasoningQty = this.read('seasoningQty', 1);
      const bagBoxQty = this.read('bagBoxQty', 1);

      // Unit costs: quantity purchased does not change what one serving costs.
      const supplyCost =
        this.perServing(values.kernelCost, this.dataset.servingsPerKernelBag) +
        this.perServing(values.oilCost, this.dataset.servingsPerOilContainer) +
        this.perServing(values.seasoningCost, this.dataset.servingsPerSeasoningContainer) +
        this.perServing(values.bagBoxCost, this.dataset.servingsPerBagBox);

      const weeksPerMonth = Number(this.dataset.weeksPerMonth) || 4.3;
      const profitPerServing = values.retailPrice - supplyCost;
      const monthlyProfit =
        profitPerServing * values.servingsPerDay * values.daysPerWeek * weeksPerMonth;
      const yearlyProfit = monthlyProfit * values.monthsPerYear;

      const orderTotal =
        values.kernelCost * kernelQty +
        values.oilCost * oilQty +
        values.seasoningCost * seasoningQty +
        values.bagBoxCost * bagBoxQty;

      this.setResult('supplyCost', supplyCost);
      this.setResult('profitPerServing', profitPerServing);
      this.setResult('monthlyProfit', monthlyProfit);
      this.setResult('yearlyProfit', yearlyProfit);
      this.setResult('orderTotal', orderTotal);
    }
  }

  if (!customElements.get('popcorn-calculator')) {
    customElements.define('popcorn-calculator', PopcornCalculator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecs extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-recs-track]');
      this.prev = this.querySelector('[data-recs-prev]');
      this.next = this.querySelector('[data-recs-next]');
      if (!this.track) return;
      if (!this.track.children.length && this.dataset.url) {
        this.load();
      } else {
        this.sync();
      }
      if (this.prev) this.prev.addEventListener('click', () => this.scroll(-1));
      if (this.next) this.next.addEventListener('click', () => this.scroll(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
    }

    async load() {
      try {
        const res = await fetch(this.dataset.url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incoming = doc.querySelector('[data-recs-track]');
        if (!incoming || !incoming.children.length) {
          this.hidden = true;
          return;
        }
        this.track.innerHTML = incoming.innerHTML;
        this.sync();
      } catch (e) {
        this.hidden = true;
      }
    }

    scroll(dir) {
      const item = this.track.querySelector('.product-recs__item');
      const step = item ? item.getBoundingClientRect().width + 12 : 280;
      this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    sync() {
      if (!this.track.children.length) {
        this.hidden = true;
        return;
      }
      this.hidden = false;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
      if (this.next)
        this.next.disabled =
          this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
    }
  }
  if (!customElements.get('product-recs')) customElements.define('product-recs', ProductRecs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.teardownPriceBindings();
      this.jsonEl = this.querySelector('[data-pdp-json]');
      this.product = this.jsonEl ? JSON.parse(this.jsonEl.textContent) : null;
      this.variantInput = this.querySelector('[data-pdp-variant-id]');
      this.atc = this.querySelector('[data-pdp-atc]');
      this.priceRoot = this.querySelector('[data-pdp-price]');
      this.priceEach = this.querySelector('[data-pdp-price-each]');
      this.priceCurrent = this.querySelector('[data-pdp-price-current]');
      this.priceCompare = this.querySelector('[data-pdp-price-compare]');
      this.skuEl = this.querySelector('[data-pdp-sku]');
      this.stage = this.querySelector('[data-pdp-stage]');
      this.qtyInput = this.querySelector('form[data-product-form] input[name="quantity"]');
      this.onSealPriceUpdate = this.handleSealPriceUpdate.bind(this);
      this.onProductQtyChange = this.handleProductQtyChange.bind(this);
      this.unitPrice = this.readUnitPrice();
      this.unitCompare = this.readUnitCompare();
      this.bindGallery();
      this.bindZoom();
      this.bindOptions();
      this.bindQty(this);
      this.bindProductQty();
      this.bindSeal();
      this.bindExtras();
      this.applyDisplayedPrice();
    }

    disconnectedCallback() {
      this.teardownPriceBindings();
    }

    teardownPriceBindings() {
      document.removeEventListener('sealsubs:price_update', this.onSealPriceUpdate);
      if (this.qtyInput && this.onProductQtyChange) {
        this.qtyInput.removeEventListener('input', this.onProductQtyChange);
        this.qtyInput.removeEventListener('change', this.onProductQtyChange);
      }
    }

    resetZoom() {
      if (!this.stage) return;
      this.stage.classList.remove('is-zooming');
      this.stage.classList.remove('is-hover');
      this.stage.style.removeProperty('--zoom-x');
      this.stage.style.removeProperty('--zoom-y');
      this.stage.style.removeProperty('--cursor-x');
      this.stage.style.removeProperty('--cursor-y');
      if (this.stage.dataset.labelZoomIn) {
        this.stage.setAttribute('aria-label', this.stage.dataset.labelZoomIn);
      }
    }

    setZoomPoint(clientX, clientY) {
      if (!this.stage) return null;
      const rect = this.stage.getBoundingClientRect();
      if (!rect.width || !rect.height) return null;
      const x = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((clientY - rect.top) / rect.height) * 100));
      this.stage.style.setProperty('--cursor-x', x + '%');
      this.stage.style.setProperty('--cursor-y', y + '%');
      return { x, y };
    }

    applyZoomSrc(img) {
      if (!img) return;
      const zoomSrc = img.dataset.zoomSrc;
      if (zoomSrc && img.dataset.zoomApplied !== zoomSrc) {
        img.src = zoomSrc;
        img.srcset = '';
        img.dataset.zoomApplied = zoomSrc;
      }
    }

    setZoomed(zoomed, point) {
      if (!this.stage) return;
      const img = this.stage.querySelector('.pdp__stage-img');
      if (!img) return;
      if (zoomed) {
        if (point) {
          this.stage.style.setProperty('--zoom-x', point.x + '%');
          this.stage.style.setProperty('--zoom-y', point.y + '%');
        }
        this.applyZoomSrc(img);
        this.stage.classList.add('is-zooming');
        if (this.stage.dataset.labelZoomOut) {
          this.stage.setAttribute('aria-label', this.stage.dataset.labelZoomOut);
        }
      } else {
        this.stage.classList.remove('is-zooming');
        this.stage.style.removeProperty('--zoom-x');
        this.stage.style.removeProperty('--zoom-y');
        if (this.stage.dataset.labelZoomIn) {
          this.stage.setAttribute('aria-label', this.stage.dataset.labelZoomIn);
        }
      }
    }

    zoomSrcFromPreview(src) {
      if (!src) return '';
      if (/_\d+x\.[^.]+(\?|$)/.test(src)) {
        return src.replace(/_\d+x(\.[^.]+)(\?|$)/, '_2400x$1$2');
      }
      return src.replace(/(\.[^.]+)(\?|$)/, '_2400x$1$2');
    }

    bindZoom() {
      if (!this.stage) return;
      const canHover =
        window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!canHover) return;
      if (!this.stage.querySelector('.pdp__stage-img')) return;

      this.stage.addEventListener('mouseenter', () => {
        this.stage.classList.add('is-hover');
      });

      this.stage.addEventListener('mousemove', (event) => {
        const point = this.setZoomPoint(event.clientX, event.clientY);
        if (!point) return;
        if (this.stage.classList.contains('is-zooming')) {
          this.stage.style.setProperty('--zoom-x', point.x + '%');
          this.stage.style.setProperty('--zoom-y', point.y + '%');
        }
      });

      this.stage.addEventListener('click', (event) => {
        const img = this.stage.querySelector('.pdp__stage-img');
        if (!img) return;
        const point = this.setZoomPoint(event.clientX, event.clientY) || { x: 50, y: 50 };
        const next = !this.stage.classList.contains('is-zooming');
        this.setZoomed(next, point);
      });

      this.stage.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        const next = !this.stage.classList.contains('is-zooming');
        this.setZoomed(next, { x: 50, y: 50 });
      });

      this.stage.addEventListener('mouseleave', () => this.resetZoom());
    }

    bindGallery() {
      this.querySelectorAll('.pdp__thumb').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const id = thumb.dataset.mediaId;
          const media = (this.product.media || []).find((m) => String(m.id) === String(id));
          if (!media || !this.stage) return;
          this.resetZoom();
          this.querySelectorAll('.pdp__thumb').forEach((t) => t.classList.toggle('is-active', t === thumb));
          const img = this.stage.querySelector('img');
          if (img && media.preview_image) {
            const preview = media.preview_image.src;
            img.src = preview.replace(/(\.[^.]+)(\?|$)/, '_1264x$1$2');
            img.srcset = '';
            img.dataset.mediaId = media.id;
            img.dataset.zoomSrc = this.zoomSrcFromPreview(preview);
            delete img.dataset.zoomApplied;
          }
        });
      });
    }

    bindOptions() {
      this.querySelectorAll('.pdp__option-input').forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange());
      });
    }

    selectedOptions() {
      return Array.from(this.querySelectorAll('.pdp__option')).map((fieldset) => {
        const checked = fieldset.querySelector('.pdp__option-input:checked');
        return checked ? checked.value : null;
      });
    }

    findVariant(options) {
      return (this.product.variants || []).find((variant) =>
        options.every((value, index) => variant['option' + (index + 1)] === value)
      );
    }

    onOptionChange() {
      const options = this.selectedOptions();
      this.querySelectorAll('[data-option-value]').forEach((el, i) => {
        if (options[i]) el.textContent = options[i];
      });
      const variant = this.findVariant(options);
      if (!variant) return;
      if (this.variantInput) this.variantInput.value = variant.id;
      this.setUnitPrices(Number(variant.price) || 0, Number(variant.compare_at_price) || 0);
      this.applyDisplayedPrice();
      this.refreshSealWidget();
      if (this.atc) {
        this.atc.disabled = !variant.available;
        this.atc.textContent = variant.available
          ? this.atc.dataset.labelAvailable
          : this.atc.dataset.labelSoldOut;
      }
      if (this.skuEl) {
        if (variant.sku) {
          const template = this.skuEl.dataset.skuTemplate || 'Item number: __SKU__';
          this.skuEl.textContent = template.replace('__SKU__', variant.sku);
          this.skuEl.hidden = false;
        } else {
          this.skuEl.textContent = '';
          this.skuEl.hidden = true;
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      this.refreshAvailability(variant.id);
      if (variant.featured_media) {
        const thumb = this.querySelector('.pdp__thumb[data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
    }

    // Store stock lives in per-variant fields rendered server-side, so re-render
    // this section for the new variant and copy its stock flags across. The
    // element itself stays put because the store drawer bound its click handler
    // directly to the store row.
    refreshAvailability(variantId) {
      const current = this.querySelector('product-availability.pdp__availability');
      if (!current || !this.dataset.sectionId) return;
      if (this.availabilityRequest) this.availabilityRequest.abort();
      const controller = new AbortController();
      this.availabilityRequest = controller;

      const url = new URL(this.dataset.productUrl || window.location.pathname, window.location.origin);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', this.dataset.sectionId);

      fetch(url.toString(), { signal: controller.signal })
        .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const next = doc.querySelector('product-availability.pdp__availability');
          if (!next) return;
          ['nsInstock', 'nlInstock', 'onlineAvailable'].forEach((key) => {
            current.dataset[key] = next.dataset[key];
          });
          if (typeof current.refresh === 'function') current.refresh();
        })
        .catch(() => {});
    }

    // Mirrors Liquid's `money` filter. Going through Intl instead spelled the
    // same amount differently ("CA$38.99" against "$38.99"), so the heading
    // changed currency style the moment this rewrote it on load.
    formatMoney(cents) {
      const value = Number(cents) || 0;
      const format = this.dataset.moneyFormat;

      const withDelimiters = (precision, thousands, decimal) => {
        const parts = (value / 100).toFixed(precision).split('.');
        const whole = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
        return parts.length > 1 ? whole + decimal + parts[1] : whole;
      };

      if (format) {
        return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_match, token) => {
          switch (token) {
            case 'amount_no_decimals':
              return withDelimiters(0, ',', '.');
            case 'amount_with_comma_separator':
              return withDelimiters(2, '.', ',');
            case 'amount_no_decimals_with_comma_separator':
              return withDelimiters(0, '.', ',');
            default:
              return withDelimiters(2, ',', '.');
          }
        });
      }

      return '$' + withDelimiters(2, ',', '.');
    }

    refreshAffirm(priceCents) {
      const nodes = this.querySelectorAll('[data-pdp-affirm], .affirm-as-low-as');
      if (!nodes.length) return;
      nodes.forEach((el) => el.setAttribute('data-amount', String(priceCents)));
      if (window.affirm && affirm.ui && typeof affirm.ui.refresh === 'function') {
        affirm.ui.refresh();
      }
    }

    readUnitPrice() {
      const fromData = Number(this.priceRoot?.dataset.unitPrice);
      if (Number.isFinite(fromData) && fromData >= 0) return fromData;
      const variant = this.currentVariant();
      return variant ? Number(variant.price) || 0 : 0;
    }

    readUnitCompare() {
      const fromData = Number(this.priceRoot?.dataset.unitCompare);
      if (Number.isFinite(fromData) && fromData >= 0) return fromData;
      const variant = this.currentVariant();
      return variant ? Number(variant.compare_at_price) || 0 : 0;
    }

    currentVariant() {
      const id = this.variantInput ? Number(this.variantInput.value) : NaN;
      if (Number.isFinite(id) && this.product) {
        const found = (this.product.variants || []).find((variant) => Number(variant.id) === id);
        if (found) return found;
      }
      return (this.product && this.product.variants && this.product.variants[0]) || null;
    }

    productQuantity() {
      if (!this.qtyInput) return 1;
      return Math.max(1, parseInt(this.qtyInput.value || '1', 10) || 1);
    }

    setUnitPrices(price, compare) {
      this.unitPrice = Number.isFinite(price) ? price : this.unitPrice || 0;
      this.unitCompare = Number.isFinite(compare) ? compare : 0;
      if (this.priceRoot) {
        this.priceRoot.dataset.unitPrice = String(this.unitPrice);
        this.priceRoot.dataset.unitCompare = String(this.unitCompare || 0);
      }
    }

    normalizeSealAmount(value, fallback) {
      if (value == null || value === '') return fallback;
      const n = Number(value);
      if (!Number.isFinite(n)) return fallback;
      if (Math.abs(n - Math.round(n)) > 0.001) return Math.round(n * 100);
      const cents = Math.round(n);
      const variant = this.currentVariant();
      const variantPrice = variant ? Number(variant.price) || 0 : 0;
      if (variantPrice >= 100 && cents > 0 && cents < variantPrice / 10) {
        return Math.round(cents * 100);
      }
      return cents;
    }

    applyDisplayedPrice() {
      const qty = this.productQuantity();
      const total = (this.unitPrice || 0) * qty;
      const compareTotal = (this.unitCompare || 0) * qty;
      if (this.priceCurrent) this.priceCurrent.textContent = this.formatMoney(total);
      if (this.priceCompare) {
        if (compareTotal > total) {
          this.priceCompare.hidden = false;
          this.priceCompare.textContent = this.formatMoney(compareTotal);
        } else {
          this.priceCompare.hidden = true;
        }
      }
      if (this.priceEach) {
        this.priceEach.hidden = qty < 2 || !this.unitPrice;
        this.priceEach.textContent = this.priceEach.hidden
          ? ''
          : (this.priceEach.dataset.eachTemplate || '__PRICE__ each')
              .split('__PRICE__')
              .join(this.formatMoney(this.unitPrice));
      }
      this.refreshAffirm(total);
    }

    handleProductQtyChange() {
      this.applyDisplayedPrice();
    }

    bindProductQty() {
      if (!this.qtyInput) return;
      this.qtyInput.addEventListener('input', this.onProductQtyChange);
      this.qtyInput.addEventListener('change', this.onProductQtyChange);
    }

    handleSealPriceUpdate(event) {
      const detail = event.detail || {};
      if (detail.element && !this.contains(detail.element)) return;
      this.setUnitPrices(
        this.normalizeSealAmount(detail.price, this.unitPrice),
        this.normalizeSealAmount(detail.compareAtPrice, this.unitCompare)
      );
      this.applyDisplayedPrice();
      requestAnimationFrame(() => this.applyDisplayedPrice());
    }

    bindSeal() {
      document.addEventListener('sealsubs:price_update', this.onSealPriceUpdate);
    }

    refreshSealWidget() {
      if (typeof window.SealSubs !== 'undefined' && typeof window.SealSubs.refresh === 'function') {
        window.SealSubs.refresh();
      }
    }

    bindQty(root) {
      root.querySelectorAll('[data-qty]').forEach((wrap) => {
        const input = wrap.querySelector('[data-qty-input]');
        const minus = wrap.querySelector('[data-qty-minus]');
        const plus = wrap.querySelector('[data-qty-plus]');
        if (!input) return;
        const set = (n) => {
          input.value = String(Math.max(1, n));
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        };
        if (minus) minus.addEventListener('click', () => set(parseInt(input.value || '1', 10) - 1));
        if (plus) plus.addEventListener('click', () => set(parseInt(input.value || '1', 10) + 1));
      });
    }

    bindExtras() {
      const root = this.querySelector('[data-pdp-extras]');
      if (!root) return;
      const atc = root.querySelector('[data-extras-atc]');
      const subtotalEl = root.querySelector('[data-extras-subtotal]');
      const countLabel = root.querySelector('[data-extras-count-label]');
      const sync = () => {
        let count = 0;
        let subtotal = 0;
        root.querySelectorAll('.pdp__extra').forEach((row) => {
          const on = row.classList.contains('is-selected');
          const qtyInput = row.querySelector('[data-extra-qty]');
          if (qtyInput) qtyInput.disabled = !on;
          if (!on) return;
          const qty = Math.max(1, parseInt(qtyInput?.value || '1', 10));
          count += 1;
          subtotal += qty * parseInt(row.dataset.extraPrice || '0', 10);
        });
        if (subtotalEl) subtotalEl.textContent = this.formatMoney(subtotal);
        if (countLabel) {
          const template = countLabel.dataset.labelTemplate || 'Subtotal (__COUNT__)';
          countLabel.textContent = template.replace('__COUNT__', String(count));
        }
        if (atc) atc.disabled = count === 0;
      };
      root.querySelectorAll('[data-extra-toggle]').forEach((box) => {
        box.addEventListener('change', () => {
          box.closest('.pdp__extra')?.classList.toggle('is-selected', box.checked);
          sync();
        });
      });
      root.querySelectorAll('[data-extra-qty]').forEach((input) => input.addEventListener('change', sync));
      if (atc) {
        atc.addEventListener('click', async () => {
          const items = [];
          root.querySelectorAll('.pdp__extra.is-selected').forEach((row) => {
            const qty = Math.max(1, parseInt(row.querySelector('[data-extra-qty]')?.value || '1', 10));
            items.push({ id: Number(row.dataset.extraId), quantity: qty });
          });
          if (!items.length) return;
          atc.disabled = true;
          atc.setAttribute('aria-busy', 'true');
          const drawer = document.querySelector('cart-drawer');
          const wasEmpty =
            typeof window.__getHeaderCartCount === 'function' ? window.__getHeaderCartCount() === 0 : false;
          const payload = { items };
          if (drawer && drawer.sectionId) payload.sections = drawer.sectionId;
          try {
            const addUrl =
              (drawer && drawer.dataset.cartAddUrl
                ? drawer.dataset.cartAddUrl
                : (window.Shopify?.routes?.root || '/') + 'cart/add') + '.js';
            const res = await fetch(addUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(payload),
            });
            const data = await res.json();
            if (!res.ok) {
              if (drawer && typeof drawer.showError === 'function') {
                drawer.showError(data.description || data.message || 'Could not add to cart.');
                drawer.open();
              }
              return;
            }
            if (drawer && data.sections && drawer.sectionId && data.sections[drawer.sectionId]) {
              drawer.replaceContents(data.sections[drawer.sectionId]);
            }
            const cartUrl = (drawer && drawer.dataset.cartUrl ? drawer.dataset.cartUrl : '/cart') + '.js';
            const cart = await (await fetch(cartUrl)).json();
            if (typeof window.__afterCartAdd === 'function') {
              window.__afterCartAdd({
                wasEmpty,
                cart,
                item: typeof window.__cartAddItemFromResponse === 'function'
                  ? window.__cartAddItemFromResponse(data)
                  : { image: '', title: '', quantity: items.reduce((n, i) => n + i.quantity, 0) },
              });
            } else {
              const toggle = document.querySelector('[data-cart-drawer-toggle]');
              if (toggle) toggle.click();
            }
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } finally {
            atc.removeAttribute('aria-busy');
            sync();
          }
        });
      }
      sync();
    }
  }
  if (!customElements.get('product-page')) customElements.define('product-page', ProductPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class RecentlyViewed extends HTMLElement {
    async connectedCallback() {
      this.track = this.querySelector('[data-recent-track]');
      const prev = this.querySelector('[data-rail-prev]');
      const next = this.querySelector('[data-rail-next]');
      let handles = [];
      try {
        handles = JSON.parse(localStorage.getItem('bigerics:recently') || '[]');
      } catch (e) { handles = []; }
      handles = handles.filter((h) => h);
      if (!handles.length) return;

      // Walk the full history and keep fetching past skipped entries
      // (deleted products 404; image-less ones return no card) until the
      // rail is full.
      const limit = parseInt(this.dataset.limit, 10) || 10;
      for (const handle of handles) {
        if (this.track.children.length >= limit) break;
        try {
          const res = await fetch('/products/' + encodeURIComponent(handle) + '?section_id=mini-card');
          if (!res.ok) continue;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const card = doc.querySelector('[data-mini-card]');
          if (card) this.track.appendChild(card);
        } catch (e) { /* skip */ }
      }
      if (!this.track.children.length) return;
      this.hidden = false;

      const step = () => this.track.clientWidth * 0.8;
      if (prev) prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      if (window.Wishlist) window.Wishlist.reflect();
    }
  }
  if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-articles"] && !Shopify.designMode) return;
  try {
    
  class RelatedArticles extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-related-track]');
      this.previousButton = this.querySelector('[data-related-prev]');
      this.nextButton = this.querySelector('[data-related-next]');

      if (!this.track) return;

      this.previousButton?.addEventListener('click', () => this.scroll(-1));
      this.nextButton?.addEventListener('click', () => this.scroll(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      window.addEventListener('resize', () => this.sync());
      this.sync();
    }

    scroll(direction) {
      const item = this.track.querySelector('[data-related-item]');
      const distance = item ? item.getBoundingClientRect().width + 16 : this.track.clientWidth;
      this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    sync() {
      if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 1;
      if (this.nextButton) {
        this.nextButton.disabled =
          this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
      }
    }
  }

  if (!customElements.get('related-articles')) {
    customElements.define('related-articles', RelatedArticles);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-products"] && !Shopify.designMode) return;
  try {
    
  class SaleRail extends HTMLElement {
    connectedCallback() {
      this.tracks = Array.from(this.querySelectorAll('[data-rail-track]'));
      this.pills = Array.from(this.querySelectorAll('[data-rail-tab]'));
      this.prev = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      if (!this.tracks.length) return;
      this.pills.forEach((pill) =>
        pill.addEventListener('click', () => this.activate(pill.dataset.railTab))
      );
      if (this.prev) this.prev.addEventListener('click', () => this.scrollTrack(-1));
      if (this.next) this.next.addEventListener('click', () => this.scrollTrack(1));
      this.tracks.forEach((t) => t.addEventListener('scroll', () => this.sync(), { passive: true }));
      this.sync();
    }

    get track() {
      return this.tracks.find((t) => !t.hidden) || this.tracks[0];
    }

    scrollTrack(dir) {
      const item = this.track.querySelector('.sale-rail__item');
      const step = item ? item.getBoundingClientRect().width + 12 : 300;
      this.track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
    }

    activate(index) {
      this.tracks.forEach((t) => (t.hidden = t.dataset.railPanel !== index));
      this.pills.forEach((p) => p.classList.toggle('sale-pill--active', p.dataset.railTab === index));
      const active = this.pills.find((p) => p.dataset.railTab === index);
      if (active) active.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      this.sync();
    }

    sync() {
      const t = this.track;
      if (!t) return;
      if (this.prev) this.prev.disabled = t.scrollLeft <= 1;
      if (this.next) this.next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 1;
    }
  }
  if (!customElements.get('sale-rail')) customElements.define('sale-rail', SaleRail);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  class SearchPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.grid = this.querySelector('[data-product-grid]');
      this.moreWrap = this.querySelector('[data-load-more-wrap]');
      this.moreBtn = this.querySelector('[data-load-more]');
      this.sentinel = this.querySelector('[data-load-sentinel]');
      this.isLoading = false;

      if (this.moreBtn) this.moreBtn.addEventListener('click', () => this.loadMore());
      this.initInfiniteScroll();
    }

    disconnectedCallback() {
      this.loadObserver?.disconnect();
    }

    initInfiniteScroll() {
      if (!this.sentinel || typeof IntersectionObserver === 'undefined') return;

      this.loadObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry?.isIntersecting) return;
          if (this.isLoading || !this.moreBtn?.dataset.nextUrl) return;
          this.loadMore();
        },
        { rootMargin: '320px 0px 0px' }
      );

      this.loadObserver.observe(this.sentinel);
    }

    async loadMore() {
      if (this.isLoading || !this.moreBtn || !this.grid) return;
      const nextUrl = this.moreBtn.dataset.nextUrl;
      if (!nextUrl) return;

      this.isLoading = true;
      this.moreBtn.disabled = true;
      this.grid.setAttribute('aria-busy', 'true');

      try {
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);
        const res = await fetch(url.toString(), { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Failed');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.querySelector('[data-product-grid]');
        if (nextGrid) {
          nextGrid.querySelectorAll('[data-col-item]').forEach((item) => {
            this.grid.appendChild(item);
          });
        }

        const nextMore = doc.querySelector('[data-load-more]');
        if (nextMore?.dataset.nextUrl) {
          this.moreBtn.dataset.nextUrl = nextMore.dataset.nextUrl;
          this.moreBtn.disabled = false;
        } else {
          delete this.moreBtn.dataset.nextUrl;
          if (this.moreWrap) this.moreWrap.hidden = true;
          if (this.sentinel) {
            this.sentinel.hidden = true;
            this.loadObserver?.unobserve(this.sentinel);
          }
        }

        if (nextGrid && this.grid) {
          this.grid.dataset.shown = nextGrid.dataset.shown;
          this.grid.dataset.page = nextGrid.dataset.page;
        }
      } catch (e) {
        this.moreBtn.disabled = false;
      } finally {
        this.isLoading = false;
        this.grid.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('search-page')) {
    customElements.define('search-page', SearchPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-support"] && !Shopify.designMode) return;
  try {
    
  class ServicesRow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rail-track]');
      const prev = this.querySelector('[data-rail-prev]');
      const next = this.querySelector('[data-rail-next]');
      if (!this.track) return;
      const step = () => this.track.clientWidth * 0.8;
      if (prev) prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      const sync = () => {
        const scrollable = this.track.scrollWidth > this.track.clientWidth + 1;
        if (prev) prev.disabled = !scrollable || this.track.scrollLeft <= 1;
        if (next) next.disabled = !scrollable || this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
      };
      this.track.addEventListener('scroll', sync, { passive: true });
      sync();
    }
  }
  if (!customElements.get('services-row')) customElements.define('services-row', ServicesRow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-drawer"] && !Shopify.designMode) return;
  try {
    
  class StoreDrawer extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-store-panel]'));
      if (!this.panels.length) return;

      this.json = JSON.parse(this.querySelector('[data-store-json]')?.textContent || '{}');
      this.switchBtn = this.querySelector('[data-store-switch]');
      this.pageBtn = this.querySelector('[data-store-page]');
      this.labels = document.querySelectorAll('[data-store-label]');
      this.key = 'bigerics:store';

      this.querySelectorAll('[data-store-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
      document.querySelectorAll('[data-store-drawer-toggle]').forEach((btn) =>
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        })
      );
      if (this.switchBtn) this.switchBtn.addEventListener('click', () => this.cycleStore());
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
      });

      const saved = this.read();
      if (saved && this.panelFor(saved)) {
        this.select(saved, false);
      } else {
        this.select(this.json.defaultHandle || this.panels[0].dataset.storePanel, false);
        this.detectLocation();
      }
      this.updateStatuses();
      setInterval(() => this.updateStatuses(), 60000);
    }

    panelFor(handle) {
      return this.panels.find((p) => p.dataset.storePanel === handle);
    }

    read() {
      try {
        return localStorage.getItem(this.key);
      } catch (e) {
        return null;
      }
    }

    write(handle) {
      try {
        localStorage.setItem(this.key, handle);
      } catch (e) {
        /* ignore */
      }
    }

    open() {
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(() => {
        if (!this.classList.contains('is-open')) this.hidden = true;
      }, 220);
    }

    select(handle, persist) {
      const panel = this.panelFor(handle);
      if (!panel) return;
      this.active = handle;
      this.panels.forEach((p) => {
        const on = p === panel;
        p.hidden = !on;
        const title = p.querySelector('.store-drawer__title');
        if (title) {
          if (on) {
            title.id = 'store-drawer-title';
            title.removeAttribute('aria-hidden');
          } else {
            title.removeAttribute('id');
            title.setAttribute('aria-hidden', 'true');
          }
        }
      });
      this.labels.forEach((el) => {
        el.textContent = panel.dataset.storeShort || handle;
      });
      if (this.pageBtn) {
        const url = (this.json.pages && this.json.pages[handle]) || this.json.contactUrl || '/pages/contact';
        this.pageBtn.href = url;
        this.pageBtn.hidden = false;
      }
      if (this.switchBtn && this.panels.length > 1) {
        const next = this.nextPanel();
        const tpl = this.json.labels?.switchTo || 'Switch to %store%';
        this.switchBtn.textContent = tpl.replace('%store%', next.dataset.storeShort || next.dataset.storePanel);
      }
      if (persist !== false) this.write(handle);
      this.updateStatuses();
      document.dispatchEvent(
        new CustomEvent('store:changed', { detail: { handle: handle } })
      );
    }

    nextPanel() {
      const i = this.panels.findIndex((p) => p.dataset.storePanel === this.active);
      return this.panels[(i + 1) % this.panels.length];
    }

    cycleStore() {
      const next = this.nextPanel();
      if (next) this.select(next.dataset.storePanel, true);
    }

    parseTime(value) {
      if (!value) return null;
      const parts = String(value).split(':');
      const h = parseInt(parts[0], 10);
      const m = parseInt(parts[1] || '0', 10);
      if (Number.isNaN(h)) return null;
      return h * 60 + m;
    }

    formatTime(mins) {
      let h = Math.floor(mins / 60);
      const m = mins % 60;
      const suffix = h >= 12 ? 'p.m.' : 'a.m.';
      h = h % 12;
      if (h === 0) h = 12;
      return m ? h + ':' + String(m).padStart(2, '0') + ' ' + suffix : h + ':00 ' + suffix;
    }

    updateStatuses() {
      this.panels.forEach((panel) => {
        const el = panel.querySelector('[data-store-status]');
        if (!el) return;
        const tz = panel.dataset.storeTimezone || 'America/Halifax';
        let day;
        let minutes;
        try {
          const parts = new Intl.DateTimeFormat('en-CA', {
            timeZone: tz,
            weekday: 'short',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          }).formatToParts(new Date());
          const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
          day = map.weekday;
          minutes = parseInt(map.hour, 10) * 60 + parseInt(map.minute, 10);
        } catch (e) {
          const now = new Date();
          day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][now.getDay()];
          minutes = now.getHours() * 60 + now.getMinutes();
        }

        let open = null;
        let close = null;
        if (day === 'Sat') {
          open = this.parseTime(panel.dataset.saturdayOpen);
          close = this.parseTime(panel.dataset.saturdayClose);
        } else if (day !== 'Sun') {
          open = this.parseTime(panel.dataset.weekdayOpen);
          close = this.parseTime(panel.dataset.weekdayClose);
        }

        const labels = this.json.labels || {};
        if (open == null || close == null) {
          el.textContent = labels.closed || 'Closed';
          return;
        }
        if (minutes >= open && minutes < close) {
          el.textContent = (labels.openUntil || 'Open until %time%').replace(
            '%time%',
            this.formatTime(close)
          );
        } else if (minutes < open) {
          el.textContent = (labels.opensAt || 'Opens at %time%').replace(
            '%time%',
            this.formatTime(open)
          );
        } else {
          el.textContent = labels.closed || 'Closed';
        }
      });
    }

    async detectLocation() {
      if (this.read()) return;
      try {
        const pos = await this.geolocate();
        if (pos) {
          const nearest = this.nearestStore(pos.lat, pos.lng);
          if (nearest) {
            this.select(nearest, true);
            return;
          }
        }
      } catch (e) {
        /* fall through to IP */
      }
      try {
        const region = await this.ipRegion();
        if (region) {
          const match = this.panels.find((p) =>
            (p.dataset.storeRegions || '')
              .toUpperCase()
              .split(/[\s,]+/)
              .filter(Boolean)
              .includes(region)
          );
          if (match) this.select(match.dataset.storePanel, true);
        }
      } catch (e) {
        /* keep default */
      }
    }

    geolocate() {
      return new Promise((resolve) => {
        if (!navigator.geolocation) return resolve(null);
        navigator.geolocation.getCurrentPosition(
          (res) => resolve({ lat: res.coords.latitude, lng: res.coords.longitude }),
          () => resolve(null),
          { timeout: 4000, maximumAge: 86400000 }
        );
      });
    }

    nearestStore(lat, lng) {
      let best = null;
      let bestDist = Infinity;
      this.panels.forEach((p) => {
        const plat = parseFloat(p.dataset.storeLat);
        const plng = parseFloat(p.dataset.storeLng);
        if (Number.isNaN(plat) || Number.isNaN(plng)) return;
        const d = (plat - lat) * (plat - lat) + (plng - lng) * (plng - lng);
        if (d < bestDist) {
          bestDist = d;
          best = p.dataset.storePanel;
        }
      });
      return best;
    }

    async ipRegion() {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 4000);
      try {
        const res = await fetch('https://ipapi.co/json/', { signal: controller.signal });
        if (!res.ok) return null;
        const data = await res.json();
        if (data && data.country_code && data.country_code !== 'CA') return null;
        return (data.region_code || '').toUpperCase();
      } finally {
        clearTimeout(timer);
      }
    }
  }

  if (!customElements.get('store-drawer')) customElements.define('store-drawer', StoreDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  class WishlistPage extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.loading = this.querySelector('[data-wishlist-loading]');
      this.countEl = this.querySelector('[data-wishlist-page-count]');
      this._rendering = false;
      this._needsRerender = false;
      this._onChange = () => this.render();
      document.addEventListener('wishlist:change', this._onChange);
      document.addEventListener('wishlist:ready', this._onChange);
      if (window.Wishlist) this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:change', this._onChange);
      document.removeEventListener('wishlist:ready', this._onChange);
    }

    _countLabel(count) {
      const template = count === 1 ? this.dataset.countOne : this.dataset.countOther;
      return (template || String(count)).replace('__N__', String(count));
    }

    _setView(state) {
      if (this.loading) this.loading.hidden = state !== 'loading';
      if (this.grid) this.grid.hidden = state !== 'grid';
      if (this.empty) this.empty.hidden = state !== 'empty';
    }

    _productRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    _ensureSectionStyles(doc) {
      const style = doc.querySelector('style[data-section-stylesheet]');
      if (!style) return;
      if (document.querySelector('style[data-section-stylesheet][data-wishlist-card-css]')) return;
      const clone = style.cloneNode(true);
      clone.setAttribute('data-wishlist-card-css', '');
      document.head.appendChild(clone);
    }

    async render() {
      if (this._rendering) {
        this._needsRerender = true;
        return;
      }
      this._rendering = true;

      do {
        this._needsRerender = false;
        const handles = window.Wishlist ? window.Wishlist.all().filter(Boolean) : [];

        if (!handles.length) {
          this.grid.innerHTML = '';
          if (this.countEl) {
            this.countEl.hidden = true;
            this.countEl.textContent = '';
          }
          this._setView('empty');
          if (window.Wishlist) window.Wishlist.reflect();
          continue;
        }

        if (!this.grid.querySelector('[data-wishlist-item]')) {
          this._setView('loading');
        }

        const existing = new Map();
        this.grid.querySelectorAll('[data-wishlist-item]').forEach((node) => {
          existing.set(node.dataset.handle, node);
        });

        const frag = document.createDocumentFragment();
        const stale = [];

        for (const handle of handles) {
          let card = existing.get(handle);
          if (!card) {
            try {
              const res = await fetch(
                this._productRoot() + 'products/' + encodeURIComponent(handle) + '?section_id=wishlist-card'
              );
              if (!res.ok) {
                stale.push(handle);
                continue;
              }
              const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
              this._ensureSectionStyles(doc);
              card = doc.querySelector('[data-wishlist-item]');
              if (!card) {
                stale.push(handle);
                continue;
              }
            } catch (e) {
              continue;
            }
          }
          frag.appendChild(card);
        }

        this.grid.replaceChildren(frag);

        if (stale.length && window.Wishlist) {
          stale.forEach((handle) => window.Wishlist.remove(handle));
        }

        const count = this.grid.querySelectorAll('[data-wishlist-item]').length;
        if (this.countEl) {
          if (count > 0) {
            this.countEl.textContent = this._countLabel(count);
            this.countEl.hidden = false;
          } else {
            this.countEl.hidden = true;
            this.countEl.textContent = '';
          }
        }

        this._setView(count > 0 ? 'grid' : 'empty');
        if (window.Wishlist) window.Wishlist.reflect();
      } while (this._needsRerender);

      this._rendering = false;
    }
  }

  if (!customElements.get('wishlist-page')) {
    customElements.define('wishlist-page', WishlistPage);
  }

  } catch(e) { console.error(e); }
})();
})();
